<template><div>
	<div class="k-case-tree-item-tile-outer" :class="item_outer_css()" @click.stop="viewer.search_panel_to_back" @mouseover="mouseover" @mouseout="mouseout">
		<div class="k-case-tree-item-tile" :class="item_css()">
			<div v-if="!ss_framework_data.ignore_status_dates" class="k-case-tree-item-not-yet-adopted-message">This {{item_is_document?'framework':'item'}} will be officially <b>implemented</b> as of {{item.cfitem.statusStartDate}}.</div>
			<div v-if="!ss_framework_data.ignore_status_dates" class="k-case-tree-item-scheduled-no-longer-adopted-message">This {{item_is_document?'framework':'item'}} will be <b>retired</b> as of {{item.cfitem.statusEndDate}}.</div>
			<div v-if="!ss_framework_data.ignore_status_dates" class="k-case-tree-item-no-longer-adopted-message">This {{item_is_document?'framework':'item'}} has been <b>retired</b> as of {{item.cfitem.statusEndDate}}.</div>
		
			<k-btn v-if="expanded_tile" class="k-case-tree-item-tile-close-btn" icon outlined small accessible-label="Collapse expanded item" @click.stop="$emit('full_screen_compressed')"><k-icon small color="grey darken-2">fas fa-compress</k-icon></k-btn>
			<k-btn v-if="!inline&&!pinned_tile&&!expanded_tile" class="k-case-tree-item-tile-close-btn" small icon color="grey darken-2" accessible-label="Close item tile" @click.stop="close_tile"><k-icon>fas fa-times-circle</k-icon></k-btn>
			<k-btn v-if="!inline&&pinned_tile" class="k-case-tree-item-tile-close-btn" small icon color="red" accessible-label="Unpin item tile" @click.stop="close_tile"><k-icon small>fas fa-thumbtack</k-icon></k-btn>

			<div v-if="!item_is_from_home_framework" class="k-case-tree-item-tile-framework-header" :class="item_framework_class" :style="item_framework_style" v-html="item_framework_description"></div>

			<div class="k-case-tree-item-tile-inner">
				<span v-if="show_chooser_btn"><k-hover v-slot:default="{hover}"><k-btn style="margin:-1px 1px 0 1px;" icon x-small :color="chooser_color(hover)" accessible-label="Choose this item" @click.stop="show_chooser_fn_clicked"><k-icon :style="chooser_style(hover)">{{chooser_icon(hover)}}</k-icon></k-btn></k-hover></span>
				<k-icon v-if="selected_items&&!show_chooser_btn" :style="selected_item_icon_style" color="primary">{{item_is_selected?'fas fa-play':'far fa-circle'}}</k-icon>

				<k-btn v-if="inline && item_is_document" class="k-case-tree-item-node-btn" x-small icon color="grey darken-2" :accessible-label="item_node_button_label"><k-icon small>fas {{is_resource_framework ? 'fa-cubes' : 'fa-map'}}</k-icon></k-btn>
				<k-btn v-if="inline && ((!item_is_document && item.children.length>0) && !is_resource_item)" class="k-case-tree-item-node-btn" :style="node_btn_style" x-small icon color="grey darken-2" :accessible-label="item_node_button_label" @click.stop="item_clicked"><k-icon small>fas fa-chevron-circle-right</k-icon></k-btn>
				<k-btn v-if="inline && (((!item_is_document && item.children.length==0) || is_resource_item))" class="k-case-tree-item-node-btn" small icon color="grey darken-2" :accessible-label="item_node_button_label" @click.stop="item_clicked"><k-icon small>fas {{is_resource_item ? 'fa-cube' : 'fa-dot-circle'}}</k-icon></k-btn>
				<div v-if="!inline" class="k-case-tree-item-node-spacer" aria-hidden="true"></div>

				<k-btn v-if="tracking_changes" class="k-case-tree-item-node-btn k-case-tree-item-track-changes-btn" style="cursor:default" x-small icon :accessible-label="tracked_change_button_label" @click.stop="tracked_change_clicked"><k-icon small>fas {{tracked_change_icon}}</k-icon></k-btn>

				<div class="k-case-tree-item-code-plus-statement">
					<k-btn v-if="!expanded_tile" class="k-case-tree-item-tile-expand-btn float-right" v-show="(!pinned_tile||!framework_record.active_node)&&!$vuetify.breakpoint.xs" :style="pinned_tile?'margin-top:-10px;margin-right:-2px;':''" small icon color="grey darken-2" accessible-label="Expand item details" @click="expand_tile"><k-icon small>fas fa-expand</k-icon></k-btn>
					<k-btn v-if="!inline&&!pinned_tile&&!item_is_document&&item_is_from_home_framework&&!$vuetify.breakpoint.xs" class="k-case-tree-item-tile-pin-btn float-right" style="margin-top:1px" small icon :color="item_is_pinned?'red':'green'" :accessible-label="item_is_pinned ? 'Unpin item tile' : 'Pin item tile'" @click="toggle_pin"><k-icon small>fas fa-thumbtack</k-icon></k-btn>
					<k-tooltip bottom><template v-slot:activator="{on}"><k-btn v-on="on" v-show="!inline&&!pinned_tile&&is_derived_item&&!$vuetify.breakpoint.xs" class="float-right" small icon color="deep-purple darken-2" accessible-label="Show derived item information" @click="derived_info_showing=true"><k-icon small>fas fa-arrow-up-from-bracket</k-icon></k-btn></template><div class="text-center">This item is derived<br>from the source framework.<br>Click for info</div></k-tooltip>
					<k-tooltip bottom><template v-slot:activator="{on}"><k-btn v-on="on" v-show="!inline&&!pinned_tile&&item_is_document&&ss_framework_data.is_mirror=='yes'&&user_can_edit&&!$vuetify.breakpoint.xs" class="float-right" style="margin-top:1px" small icon color="primary" accessible-label="Show mirror information" @click="mirror_info_showing=true"><k-icon small>fas fa-clone</k-icon></k-btn></template><div class="text-center">This framework is “mirrored”.<br>Click for info</div></k-tooltip>
					<div>
						<span v-if="stats_mode" @mouseover="stats_mouseover" @mouseout="stats_mouseout" @click.stop="stats_clicked">
							<b class="green--text" v-if="item.cfitem.stats.descendent_count>1">[{{item.cfitem.stats.descendent_count}}]</b>
							<b class="red--text" style="font-size:10px" v-if="item.cfitem.stats.items_removed>0">–{{item.cfitem.stats.items_removed}}</b>
							<span v-if="item.cfitem.stats.is_duplicate_of"><k-icon x-small color="green">fas fa-circle</k-icon></span>
							<span v-if="item.cfitem.stats.possible_related_to&&!item.cfitem.stats.is_duplicate_of"><k-icon x-small color="red">far fa-circle</k-icon></span>
							<span v-if="item.cfitem.stats.add_is_child_of_to_duplicate"><k-icon x-small color="red">fas fa-dot-circle</k-icon></span>
							<span v-if="item.cfitem.stats.to_be_deleted"><k-icon x-small color="red">fas fa-circle</k-icon></span>
						</span>

						<span @click.stop="item_clicked">
							<k-tooltip bottom><template v-slot:activator="{on}"><k-btn v-if="viewer.wiki_mode_view" v-on="on" icon small color="light-blue darken-3" class="k-help-link-btn float-right mr-1" accessible-label="Copy a link to this page" @click.stop="copy_wiki_link"><k-icon small>fas fa-link</k-icon></k-btn></template>Copy a link to this page</k-tooltip>
							<b v-if="item.cfitem.humanCodingScheme!=null" class="k-case-tree-item-statement-hcs mr-1 grey--text text--darken-2" v-html="human_coding_scheme"></b>
							<div class="k-case-tree-item-statement k-case-tree-markdown" v-html="marked_full_statement"></div>
							<span>
								<CopyBtn v-if="!inline&&!pinned_tile" :size="($vuetify.breakpoint.xs||$vuetify.breakpoint.sm)?'small':''" :val="tree_statement_for_copy()" :label="`Copy item text for ${item.cfitem.humanCodingScheme || 'item'}`" color="#666"/>
								<!-- when tile is inline, don't show the copy btn; instead show the expand button - user can go to more info and copy from there -->
								<k-btn v-if="inline" x-small icon accessible-label="Expand item details" @click.stop="expand_tile" style="height:18px;margin-top:-2px;"><k-icon small color="#666">fas fa-expand</k-icon></k-btn>
								<k-btn v-if="embedded_mode&&item_is_node&&!viewer.wiki_mode_view&&$vuetify.breakpoint.xs" x-small icon :accessible-label="limit_search_to_this_item&&search_limit_to_item ? 'Remove search limit to this item' : 'Limit search to this item'" @click.stop="limit_search_to_this_item=!limit_search_to_this_item" style="height:18px;margin-top:-2px;"><k-icon small :color="(limit_search_to_this_item&&search_limit_to_item)?'primary':'#777'">fas fa-search</k-icon></k-btn>
							</span>
						</span>
					</div>
					<div v-if="!item_is_document&&node_is_open&&progression_table_available" class="my-1"><k-btn x-small outlined color="primary" @click.stop="show_progression_table"><k-icon small class="mx-2">fas fa-forward</k-icon> Show Progression</k-btn></div>

					<div v-if="viewer.public_review_on&&!inline&&!pinned_tile&&!expanded_tile" class="k-case-tree-item-public-review-description d-flex align-center">
						<k-btn icon small accessible-label="Open public review help" @click="U.show_help('public_review_comments')" color="light-blue" class="k-help-icon-btn"><k-icon small>fas fa-info-circle</k-icon></k-btn>
						<div class="mr-1" v-html="ss_framework_data.public_review_description?ss_framework_data.public_review_description:'This framework is open for public review.'"></div>
						<k-spacer/>
						<k-tooltip bottom z-index="200"><template v-slot:activator="{on}"><k-btn v-on="on" x-small icon color="#333" class="mr-1" :outlined="(signed_in||viewer.public_review_on)&&viewer.show_comments" :accessible-label="viewer.show_comments ? 'Hide public review comments' : 'Show public review comments'" @click="viewer.toggle_show_comments"><k-icon style="font-size:12px">fas fa-comment</k-icon></k-btn></template>{{viewer.show_comments?'Hide public review comments':'Show public review comments'}}</k-tooltip>
					</div>
					<div v-if="show_tile_comments_component" class="k-tile-comments-wrapper"><TileComments :viewer="viewer" :item="item" :framework_record="framework_record" :item_identifier="item.cfitem.identifier" /></div>
					<div v-if="false" style="margin-top:-32px; margin-left:-20px;"><k-btn small color="red darken-3" class="k-tight-btn" dark @click="open_learning_check"><k-icon small class="mr-2">fas fa-bank</k-icon>Velocity Bank</k-btn></div>

					<div v-if="inline && !item_is_document && (show_identifiers_in_tiles || show_associations)" class="k-case-tree-item-details text-center mt-2">
						<div v-if="show_identifiers_in_tiles"><span class="k-case-tree-item-details-label">Identifier:</span> {{item.cfitem.identifier}}<CopyBtn :size="'small'" color="#666" :val="item.cfitem.identifier" :label="`Copy identifier for ${item.cfitem.humanCodingScheme || 'item'}`" class="ml-1"/></div>
						<CASEItemAssociations v-if="show_associations"
							:item="item"
							:home_framework_record="framework_record"
							:framework_record="framework_record"
							:viewer="viewer"
							:show_full_text="true" 
						/>
					</div>

					<div v-if="inline&&(marked_notes||marked_exemplar)&&!($vuetify.breakpoint.xs||$vuetify.breakpoint.sm)" class="text-center">
						<k-btn v-if="marked_notes||marked_exemplar" x-small color="#666" class="ma-1" text @click="show_notes_and_exemplar=!show_notes_and_exemplar">{{show_notes_and_exemplar?'Hide':'Show'}} Notes</k-btn>
					</div>
					<div class="k-case-tree-item-details" v-if="!inline||show_notes_and_exemplar">
						<!-- aligned resources -->
						<div v-if="show_aligned_resources_info" class="d-flex align-center text-center mt-2">
							<k-spacer/>
							<k-tooltip bottom z-index="200" v-if="item_is_document"><template v-slot:activator="{on}">
								<k-btn v-on="on" small class="mx-2 k-tight-btn k-nocaps-btn" text color="deep-orange darken-4" @click="move_to_first_child"><div style="font-weight:normal; font-size:15px;">
									<k-icon color="deep-orange darken-4" style="font-size:18px; margin-top:-2px;" class="mr-1">fas fa-bolt</k-icon>
									<span v-show="item_aligned_asset_count==0">See child standards for</span>
									<b v-show="item_aligned_asset_count>0">+</b><b>{{ child_aligned_asset_count }}</b>
									<span v-show="item_aligned_asset_count==0" style="font-weight:normal">aligned {{ U.ps('content item', child_aligned_asset_count) }}</span>
									<k-icon color="deep-orange darken-4" style="font-size:16px; margin-top:-2px;" class="ml-1">fas fa-chevron-circle-down</k-icon>
								</div></k-btn>
							</template>See child standards for up to {{ child_aligned_asset_count }} aligned {{ U.ps('content item', child_aligned_asset_count) }}</k-tooltip>

							<k-tooltip v-if="!item_is_document" bottom z-index="200"><template v-slot:activator="{on}">
								<k-btn v-on="on" small class="k-tight-btn k-nocaps-btn" color="deep-orange darken-4" dark @click.stop="initiate_resource_search">
									<k-icon small class="mr-2">fas fa-bolt</k-icon>
									<span style="font-weight:normal">Show</span><span class="mx-1">{{ total_aligned_asset_count }}</span><span style="font-weight:normal">Aligned {{ U.ps('Content Item', total_aligned_asset_count) }}</span>
								</k-btn>
							</template><div v-html="aligned_item_btn_tooltip" class="text-center"></div></k-tooltip>
							<k-spacer/>
						</div>

						<!-- featured extensions -->
						<div v-if="featured_extensions.length>0&&(!inline||show_notes_and_exemplar)">
							<div v-for="(fe) in featured_extensions" :key="fe.key" class="k-case-tree-item-details-notes k-case-tree-markdown">
								<div class="k-case-tree-item-details-notes-header">{{ fe.display_key }}</div>
								<span class="float-right ml-3" style="margin-right:6px;"><CopyBtn :val="fe.copy_val" color="#666"/></span>
								<div :data-extension-inner="fek(fe.key)" :style="fe_style[fek(fe.key)]" class="k-case-tree-item-details-notes-inner" v-html="fe.display_val"></div>
								<div v-if="fe_show_btn[fek(fe.key)]" class="text-center" style="margin-bottom:-8px;" :style="fe_showing[fek(fe.key)]?'':'border-top:1px solid #ccc'">
									<v-btn v-if="true" x-small block text color="secondary" style="border-radius:0" @click="toggle_fe_showing(fe.key)">Show {{fe_showing[fek(fe.key)]?'Less':'More'}}<v-icon small class="ml-2">fas fa-caret-{{fe_showing[fek(fe.key)]?'up':'down'}}</v-icon></v-btn>
								</div>
							</div>
						</div>

						<!-- notes -->
						<div v-if="marked_notes&&(!inline||show_notes_and_exemplar)" class="k-case-tree-item-details-notes k-case-tree-markdown" :key="'notes'">
							<div class="k-case-tree-item-details-notes-header">Notes</div>
							<span class="float-right ml-3" style="margin-right:6px;"><CopyBtn :val="item.cfitem.notes" color="#666"/></span>
							<div :data-extension-inner="fek('notes')" :style="fe_style[fek('notes')]" class="k-case-tree-item-details-notes-inner" v-html="marked_notes"></div>
							<div v-if="fe_show_btn[fek('notes')]" class="text-center" style="margin-bottom:-8px;" :style="fe_showing[fek('notes')]?'':'border-top:1px solid #ccc'">
								<v-btn v-if="true" x-small block text color="secondary" style="border-radius:0" @click="toggle_fe_showing('notes')">Show {{fe_showing[fek('notes')]?'Less':'More'}}<v-icon small class="ml-2">fas fa-caret-{{fe_showing[fek('notes')]?'up':'down'}}</v-icon></v-btn>
							</div>
						</div>

						<!-- exemplar -->
						<div v-if="marked_exemplar&&(!inline||show_notes_and_exemplar)" class="k-case-tree-item-details-exemplar k-case-tree-markdown" :key="'exemplar'">
							<div class="k-case-tree-item-details-exemplar-header">
								{{ss_framework_data.exemplar_label?ss_framework_data.exemplar_label:'Supplemental Information'}}
								<span v-if="exemplar_collapsible&&!expanded_tile" class="pl-3 pr-1"><a @click="toggle_exemplar">{{exemplar_collapsed_local?'EXPAND':'COLLAPSE'}}</a></span>
							<!-- <span v-if="!exemplar_collapsed_local" class="pl-1 pr-1"><k-icon color="#999" small @click="exemplar_dialog_open=true">fas fa-arrow-up-right-from-square</k-icon></span> -->
							</div>
							<div :data-extension-inner="fek('exemplar')" :style="fe_style[fek('exemplar')]" class="fr-view k-case-tree-item-details-exemplar-body k-case-tree-item-details-notes-inner" v-html="marked_exemplar"></div>
							<div v-if="fe_show_btn[fek('exemplar')]" class="text-center" style="margin-bottom:-8px;" :style="fe_showing[fek('exemplar')]?'':'border-top:1px solid #ccc'">
								<v-btn v-if="true" x-small block text color="secondary" style="border-radius:0" @click="toggle_fe_showing('exemplar')">Show {{fe_showing[fek('exemplar')]?'Less':'More'}}<v-icon small class="ml-2">fas fa-caret-{{fe_showing[fek('exemplar')]?'up':'down'}}</v-icon></v-btn>
							</div>
						</div>

						<CASEItemAssociations v-if="!inline&&(show_associations||making_associations)"
							ref="associations_component"
							:item="item"
							:home_framework_record="framework_record"
							:framework_record="framework_record"
							:viewer="viewer"
							:show_full_text="true"
							:in_expanded_tile="expanded_tile" 
							@show_rubric_from_association="show_rubric_from_association" 
						/>

						<div v-if="show_quick_align_btn" class="text-center py-2">
							<k-btn small color="primary" class="k-tight-btn k-nocaps-btn" @click="quick_align"><k-icon small class="mr-2">fas fa-cubes</k-icon> {{quick_align_btn_text}}</k-btn>
						</div>

						<div v-if="!inline&&item_is_document" class="k-case-tree-item-details-inner k-case-tree-item-details-inner-document" :class="(marked_notes||marked_exemplar)?'k-case-tree-item-details-inner-no-border':''">
							<ul class="k-list-no-bullets">
								<li v-if="item.cfitem.adoptionStatus">
									<b>Status:</b>
									<div class="k-case-tree-item-adoption-status" :class="adoption_status_css_class">
										{{adoption_status_display_value}}
										{{ ss_framework_data.is_private ? '(Private)' : '' }}
									</div>
								</li>
								<li><b>Creator:</b> {{item.cfitem.creator}}</li>
								<li v-if="item.cfitem.publisher" style="hyphens:auto"><b>Publisher:</b> {{item.cfitem.publisher}}</li>
								<li v-if="item.cfitem.language" style="hyphens:auto"><b>Language:</b> {{language_display}}</li>
								<li v-if="item.cfitem.licenseURI"><b>License:</b> {{license_title}}
									<b v-if="license_data.licenseText" style="font-size:14px" class="ml-1"><a @click="license_text_showing=!license_text_showing">{{license_text_showing?'HIDE':'SHOW'}}</a></b>
									<b v-if="!license_data.licenseText" style="font-size:14px" class="ml-1"><a target="_blank" href="item.cfitem.licenseURI.uri">LINK</a></b>
									<div v-if="license_text_showing" v-html="license_data.marked_licenseText" class="mb-2" style="text-indent:0; background-color:#eee; padding:4px; border-radius:6px;"></div>
								</li>
								<li v-if="item.cfitem.frameworkType"><b>Framework Type:</b> {{item.cfitem.frameworkType}}</li>
								<li v-if="item.cfitem.subject"><b>Subject:</b> {{cfdocument_subject}}</li>
								<!-- <li><CopyBtn :size="'small'" :val="item.cfitem.uri" class="mr-1"/><b>CASE URL:</b> <a :href="item.cfitem.uri" target="_blank">{{item.cfitem.uri}}</a></li> -->
								<li v-if="item.cfitem.officialSourceURL" style="hyphens:auto"><CopyBtn :size="'small'" :val="item.cfitem.officialSourceURL" class="mr-1"/><b>Official Source URL:</b> <a :href="item.cfitem.officialSourceURL" target="_blank">{{item.cfitem.officialSourceURL}}</a></li>
								<!-- <li v-if="item.cfitem.description" style="hyphens:auto"><CopyBtn :size="'small'" :val="item.cfitem.description" class="mr-1"/><b>Description:</b> <span class="k-marked-inline" v-html="marked(item.cfitem.description)"></span></li> -->
								<li><CopyBtn :size="'small'" :val="item.cfitem.identifier" class="mr-1" style="margin-top:-2px"/><b>Globally Unique Identifier:</b> {{item.cfitem.identifier}}</li>
								<li v-if="item.cfitem.version"><b>Version:</b> {{item.cfitem.version}}</li>
								<li><b>Last Changed:</b> {{item.cfitem.lastChangeDateTime.substr(0,10)}}</li>
							</ul>

							<!-- document description -->
							<div v-if="item.cfitem.description" class="k-case-tree-item-details-notes k-case-tree-markdown" :key="'doc_description'">
								<div class="k-case-tree-item-details-notes-header">Description</div>
								<span class="float-right ml-3" style="margin-right:6px;"><CopyBtn :val="item.cfitem.description" color="#666"/></span>
								<div :data-extension-inner="fek('doc_description')" :style="fe_style[fek('doc_description')]" class="k-case-tree-item-details-notes-inner" v-html="marked(item.cfitem.description)"></div>
								<div v-if="fe_show_btn[fek('doc_description')]" class="text-center" style="margin-bottom:-8px;" :style="fe_showing[fek('doc_description')]?'':'border-top:1px solid #ccc'">
									<v-btn v-if="true" x-small block text color="secondary" style="border-radius:0" @click="toggle_fe_showing('doc_description')">Show {{fe_showing[fek('doc_description')]?'Less':'More'}}<v-icon small class="ml-2">fas fa-caret-{{fe_showing[fek('doc_description')]?'up':'down'}}</v-icon></v-btn>
								</div>
							</div>

							<div class="text-center mt-2">
								<!-- Note that this menu should be kept in synch with the analogous menu in DocumentEditor -->
								<k-menu
									ref="framework_edit_actions_menu"
									:transition="false"
									left
									offset-y
									v-model="edit_actions_menu_showing"
									z-index="100"
									accessible-popover
									:accessible-label="framework_edit_menu_label"
									:content-id="framework_edit_menu_content_id"
								><template v-slot:activator="{on, attrs}"><k-btn v-on="on" v-bind="attrs" v-show="show_edit_button" small color="primary" class="k-tight-btn"><k-icon small class="mr-1">fas fa-edit</k-icon>Edit Framework (⌘⇧E)</k-btn></template>
									<k-list dense>
										<k-list-item v-if="viewing_home_framework" @click="edit_document('')"><k-list-item-icon><k-icon small>fas fa-edit</k-icon></k-list-item-icon><k-list-item-title>Edit document properties (⌘⇧E)</k-list-item-title></k-list-item>

										<k-menu
											v-if="!is_mirror"
											:transition="false"
											offset-x
											nudge-top="8"
											:open-on-hover="false"
											style="display: block;"
											v-model="framework_create_menu_showing"
											accessible-popover
											accessible-label="Create, copy, or import top-level child items"
											:content-id="framework_create_menu_content_id"
											:parent-menu-active="edit_actions_menu_showing"
										>
											<template v-slot:activator="{on, attrs}"><k-list-item v-if="viewing_home_framework" v-on="on" v-bind="attrs" style="cursor:pointer">
												<k-list-item-icon><k-icon small>fas fa-plus</k-icon></k-list-item-icon><k-list-item-title>Create/Copy/Import top-level child items</k-list-item-title>
												<k-list-item-action class="justify-end"><k-icon small>fas fa-chevron-right</k-icon></k-list-item-action>
											</k-list-item></template>

											<k-list dense>
												<k-list-item @click="edit_document('create_top_level_item')"><k-list-item-icon><k-icon small>fas fa-down-long</k-icon></k-list-item-icon><k-list-item-title><b>Create</b> a new top-level item (⌘⇧9)</k-list-item-title></k-list-item>
												<k-list-item @click="edit_document('show_copy_interface')"><k-list-item-icon><k-icon small>far fa-copy</k-icon></k-list-item-icon><k-list-item-title><b>Copy</b> items from this or another framework (⌘⇧C)</k-list-item-title></k-list-item>
												<k-list-item @click="edit_document('show_text_import_interface')"><k-list-item-icon><k-icon small>fas fa-file-import</k-icon></k-list-item-icon><k-list-item-title>Batch <b>import</b> items from <b>text input</b> (⌘⇧I)</k-list-item-title></k-list-item>
												<k-list-item @click="edit_document('show_csv_import_interface')"><k-list-item-icon><k-icon small>fas fa-file-csv</k-icon></k-list-item-icon><k-list-item-title>Batch <b>import</b> items from <b>CSV file</b></k-list-item-title></k-list-item>
												<k-list-item @click="export_item_interface_showing=true"><k-list-item-icon><k-icon small>fas fa-file-export</k-icon></k-list-item-icon><k-list-item-title>Export items in Satchel text format</k-list-item-title></k-list-item>
												<k-list-item v-if="!is_mirror" @click="create_child_rubric">
													<k-list-item-icon>
														<k-icon small style="transform:rotate(90deg);">fas fa-turn-up</k-icon>
													</k-list-item-icon>
													<k-list-item-title>
														Create a <b>new child rubric</b> item
													</k-list-item-title>
												</k-list-item>
											</k-list>
										</k-menu>

										<k-divider/>

										<k-list-item v-if="viewing_home_framework&&!is_mirror" @click="viewer.toggle_move_mode"><k-list-item-icon><k-icon small>fas fa-arrows-alt</k-icon></k-list-item-icon><k-list-item-title>Move items (⌘⇧.)</k-list-item-title></k-list-item>

										<k-list-item v-if="viewing_home_framework&&!is_mirror" @click="viewer.toggle_batch_edit_mode"><k-list-item-icon><k-icon small>fas fa-wand-magic-sparkles</k-icon></k-list-item-icon><k-list-item-title>Batch update items</k-list-item-title></k-list-item>

										<k-list-item @click="toggle_make_associations"><k-list-item-icon><k-icon small>fas fa-arrows-alt-h</k-icon></k-list-item-icon><k-list-item-title>Make associations</k-list-item-title></k-list-item>

										<k-divider/>

										<k-menu
											:transition="false"
											:open-on-hover="false"
											offset-x
											nudge-top="8"
											style="display: block;"
											v-model="framework_more_options_menu_showing"
											accessible-popover
											accessible-label="More framework edit options"
											:content-id="framework_more_options_menu_content_id"
											:parent-menu-active="edit_actions_menu_showing"
										>
											<template v-slot:activator="{on, attrs}"><k-list-item v-if="viewing_home_framework" v-on="on" v-bind="attrs" style="cursor:pointer">
												<k-list-item-icon><k-icon small>fas fa-ellipsis-h</k-icon></k-list-item-icon><k-list-item-title>More options</k-list-item-title>
												<k-list-item-action class="justify-end"><k-icon small>fas fa-chevron-right</k-icon></k-list-item-action>
											</k-list-item></template>

											<k-list dense>
												<k-list-item @click="viewer_fn('delete_framework')"><k-list-item-icon><k-icon small>fas fa-trash-alt</k-icon></k-list-item-icon><k-list-item-title>Delete framework…</k-list-item-title></k-list-item>

												<k-divider/>

												<k-list-item @click="edit_document('show_association_import_interface')"><k-list-item-icon><k-icon small>fas fa-file-import</k-icon></k-list-item-icon><k-list-item-title>Batch import <b>associations</b> from text input</k-list-item-title></k-list-item>
												<k-list-item v-if="!is_mirror" @click="edit_document('show_metadata_import_interface')"><k-list-item-icon><k-icon small>fas fa-file-import</k-icon></k-list-item-icon><k-list-item-title>Batch import <b>item metadata</b> from text input</k-list-item-title></k-list-item>

												<k-divider/>

												<k-list-item @click="update_rest_api"><k-list-item-icon><k-icon small>fas fa-bed</k-icon></k-list-item-icon><k-list-item-title>Update data for CASE REST API</k-list-item-title></k-list-item>
												<k-list-item v-if="user_can_admin&&!is_mirror&&!is_sandbox" @click="viewer_fn('create_sandbox')"><k-list-item-icon><k-icon small>fas fa-umbrella-beach</k-icon></k-list-item-icon><k-list-item-title>Create a “sandbox” copy of this framework</k-list-item-title></k-list-item>
												<k-list-item v-if="user_can_admin&&!is_mirror&&is_sandbox" @click="viewer_fn('apply_sandbox')"><k-list-item-icon><k-icon small>fas fa-umbrella-beach</k-icon></k-list-item-icon><k-list-item-title>Apply sandbox changes to original framework</k-list-item-title></k-list-item>						
												<k-list-item v-if="user_can_admin&&!is_sandbox" @click="viewer_fn('create_derivative')"><k-list-item-icon><k-icon small>fas fa-arrow-up-from-bracket</k-icon></k-list-item-icon><k-list-item-title>Create a “derivative” copy of this framework</k-list-item-title></k-list-item>
											</k-list>
										</k-menu>

									</k-list>
								</k-menu>

								<k-tooltip bottom z-index="200"><template v-slot:activator="{on}"><k-btn v-on="on" small color="#666" dark @click="more_info" class="ml-2 k-tight-btn"><k-icon small class="mr-1">fas fa-code</k-icon>Document Metadata</k-btn></template><div class="text-center">Show all document metadata</div></k-tooltip>
								<k-tooltip bottom z-index="200"><template v-slot:activator="{on}"><k-btn v-show="viewing_home_framework&&$vuetify.breakpoint.smAndUp&&signed_in" v-on="on" fab x-small color="#666" dark class="ml-1" :accessible-label="side_by_side_button_label" @click.stop="viewer.side_by_side_editor_head_identifier=item.cfitem.identifier"><k-icon small>fas fa-code-compare</k-icon></k-btn></template><div class="text-center">Side-by-Side Comparison<br>to Archive [BETA]</div></k-tooltip>
								<k-tooltip bottom z-index="200"><template v-slot:activator="{on}"><k-btn v-show="viewing_home_framework&&$vuetify.breakpoint.smAndUp" v-on="on" fab x-small color="#666" dark class="ml-1" :accessible-label="print_button_label" @click.stop="print_view"><k-icon small>fas fa-print</k-icon></k-btn></template>Print</k-tooltip>
								<k-tooltip bottom z-index="200"><template v-slot:activator="{on}"><k-btn v-on="on" fab x-small color="#666" dark class="ml-1" :accessible-label="qr_code_button_label" @click="show_qrcode=true"><k-icon small>fas fa-qrcode</k-icon></k-btn></template>QR Code</k-tooltip>
							</div>
						</div>
						<div v-if="!inline&&!item_is_document" class="k-case-tree-item-details-inner k-case-tree-item-details-inner-item" :class="(marked_notes||marked_exemplar)?'k-case-tree-item-details-inner-no-border':''">
							<div v-show="show_edit_button" style="flex:0 1 20px">
								<!-- Note that this menu should be kept in synch with the analogous menu in ItemEditor -->
								<k-menu
									ref="item_edit_actions_menu"
									:transition="false"
									right
									offset-y
									v-model="edit_actions_menu_showing"
									z-index="100"
									accessible-popover
									:accessible-label="item_edit_menu_label"
									:content-id="item_edit_menu_content_id"
								><template v-slot:activator="{on, attrs}"><k-btn v-on="on" v-bind="attrs" fab x-small color="primary" dark :accessible-label="edit_actions_button_label"><k-icon small>fas fa-edit</k-icon></k-btn></template>
									<k-list dense>
										<k-list-item v-if="!is_mirror&&!is_derived_item&&viewing_home_framework" @click="edit_item('')"><k-list-item-icon><k-icon small>fas fa-edit</k-icon></k-list-item-icon><k-list-item-title>Edit this item (⌘⇧E)</k-list-item-title></k-list-item>
										<k-list-item v-if="is_derived_item&&viewing_home_framework"><k-list-item-icon><k-icon small>fas fa-edit</k-icon></k-list-item-icon><k-list-item-title><i>This derived item cannot be edited.</i></k-list-item-title></k-list-item>

										<k-menu
											:transition="false"
											offset-x
											nudge-top="8"
											:open-on-hover="false"
											style="display: block;"
											v-model="item_create_menu_showing"
											accessible-popover
											accessible-label="Create, copy, import, or export child items"
											:content-id="item_create_menu_content_id"
											:parent-menu-active="edit_actions_menu_showing"
										>
											<template v-slot:activator="{on, attrs}"><k-list-item v-if="viewing_home_framework&&!expanded_tile" v-on="on" v-bind="attrs" style="cursor:pointer">
												<k-list-item-icon><k-icon small>fas fa-plus</k-icon></k-list-item-icon><k-list-item-title>Create/Copy/Import</k-list-item-title>
												<k-list-item-action class="justify-end"><k-icon small>fas fa-chevron-right</k-icon></k-list-item-action>
											</k-list-item></template>

											<k-list dense>
												<k-list-item v-if="!is_mirror" @click="edit_item('add_sibling')"><k-list-item-icon><k-icon small>fas fa-down-long</k-icon></k-list-item-icon><k-list-item-title>Create a <b>new sibling</b> item (⌘⇧0)</k-list-item-title></k-list-item>
												<k-list-item v-if="!is_mirror" @click="edit_item('add_child')"><k-list-item-icon><k-icon small style="transform:rotate(90deg);">fas fa-turn-up</k-icon></k-list-item-icon><k-list-item-title>Create a <b>new child</b> item (⌘⇧9)</k-list-item-title></k-list-item>
												<k-list-item v-if="!is_mirror" @click="edit_item('show_copy_interface')"><k-list-item-icon><k-icon small>fas fa-copy</k-icon></k-list-item-icon><k-list-item-title><b>Copy</b> child items from this or another framework (⌘⇧C)</k-list-item-title></k-list-item>
												<k-list-item v-if="!is_mirror" @click="edit_item('show_text_import_interface')"><k-list-item-icon><k-icon small>fas fa-file-import</k-icon></k-list-item-icon><k-list-item-title>Batch <b>import</b> child items from <b>text input</b> (⌘⇧I)</k-list-item-title></k-list-item>
												<k-list-item v-if="!is_mirror" @click="edit_item('show_csv_import_interface')"><k-list-item-icon><k-icon small>fas fa-file-csv</k-icon></k-list-item-icon><k-list-item-title>Batch <b>import</b> child items from <b>CSV file</b></k-list-item-title></k-list-item>
												<k-list-item @click="export_item_interface_showing=true"><k-list-item-icon><k-icon small>fas fa-file-export</k-icon></k-list-item-icon><k-list-item-title><b>Export</b> items in Satchel text format</k-list-item-title></k-list-item>
												<k-list-item v-if="!is_mirror&&!expanded_tile" @click="choose_rubric_type"><k-list-item-icon><k-icon small>fa-ballot-check</k-icon></k-list-item-icon><k-list-item-title>Create a <b>rubric</b> (BETA)</k-list-item-title></k-list-item>
											</k-list>
										</k-menu>

										<k-menu
											v-if="!is_mirror&&viewing_home_framework&&!expanded_tile&&item_is_node"
											:transition="false"
											offset-x
											nudge-top="8"
											:open-on-hover="false"
											style="display: block;"
											v-model="item_delete_menu_showing"
											accessible-popover
											accessible-label="Delete item options"
											:content-id="item_delete_menu_content_id"
											:parent-menu-active="edit_actions_menu_showing"
										>
											<template v-slot:activator="{on, attrs}"><k-list-item v-if="viewing_home_framework" v-on="on" v-bind="attrs" style="cursor:pointer">
												<k-list-item-icon><k-icon small>fas fa-trash-alt</k-icon></k-list-item-icon><k-list-item-title>Delete</k-list-item-title>
												<k-list-item-action class="justify-end"><k-icon small>fas fa-chevron-right</k-icon></k-list-item-action>
											</k-list-item></template>

											<k-list dense>
												<k-list-item @click="edit_item('delete_item')"><k-list-item-icon><k-icon small>fas fa-trash-alt</k-icon></k-list-item-icon><k-list-item-title>Delete this item and its child items</k-list-item-title></k-list-item>
												<k-list-item v-if="!expanded_tile" @click="edit_item('delete_children')"><k-list-item-icon><k-icon small>far fa-trash-alt</k-icon></k-list-item-icon><k-list-item-title>Delete this item’s child items but preserve this item</k-list-item-title></k-list-item>
												<k-list-item @click="edit_item('delete_item_not_children')"><k-list-item-icon><k-icon small>far fa-trash-alt</k-icon></k-list-item-icon><k-list-item-title>Delete this item but preserve child items</k-list-item-title></k-list-item>
											</k-list>
										</k-menu>
										<k-list-item v-if="!is_mirror&&viewing_home_framework&&!expanded_tile&&item_is_leaf" @click="edit_item('delete_item')"><k-list-item-icon><k-icon small>fas fa-trash-alt</k-icon></k-list-item-icon><k-list-item-title>Delete this item</k-list-item-title></k-list-item>

										<k-list-item v-if="!is_mirror&&viewing_home_framework&&!expanded_tile&&item_is_node" @click="viewer.sort_children(item)"><k-list-item-icon><k-icon small>fas fa-arrow-down-short-wide</k-icon></k-list-item-icon><k-list-item-title>Sort child items</k-list-item-title></k-list-item>
									
										<k-divider/>

										<k-list-item v-if="!is_mirror&&viewing_home_framework&&!expanded_tile" @click="viewer.toggle_move_mode"><k-list-item-icon><k-icon small>fas fa-arrows-alt</k-icon></k-list-item-icon><k-list-item-title>Move items (⌘⇧.)</k-list-item-title></k-list-item>

										<k-list-item v-if="!is_mirror&&viewing_home_framework&&!expanded_tile" @click="viewer.toggle_batch_edit_mode"><k-list-item-icon><k-icon small>fas fa-wand-magic-sparkles</k-icon></k-list-item-icon><k-list-item-title>Batch update items</k-list-item-title></k-list-item>

										<k-list-item v-if="!expanded_tile" @click="toggle_make_associations"><k-list-item-icon><k-icon small>fas fa-arrows-alt-h</k-icon></k-list-item-icon><k-list-item-title>Make associations</k-list-item-title></k-list-item>
									</k-list>
								</k-menu>
							</div>
							<div style="flex:0 1 100%" v-if="item_type">
								<div class="k-case-tree-item-details-label">Item Type:</div>
								<div v-html="item_type"></div>
							</div>
							<div style="flex:0 1 100%" v-if="item.cfitem.educationLevel">
								<div class="k-case-tree-item-details-label">Ed. Level:</div>
								<div v-html="education_level_display"></div>
							</div>
							<div style="flex:0 1 100%">
								<div class="k-case-tree-item-details-label">Last Changed:</div>
								<div v-html="item.cfitem.lastChangeDateTime.substr(0,10)"></div>
							</div>
							<div style="flex:0 1 20px" class="mr-2"><nobr>
								<k-tooltip bottom z-index="200"><template v-slot:activator="{on}"><k-btn v-on="on" icon small :accessible-label="item_metadata_button_label" @click.stop="more_info"><k-icon small>fas fa-code</k-icon></k-btn></template>Show all item metadata</k-tooltip>
								<k-tooltip bottom z-index="200"><template v-slot:activator="{on}"><k-btn v-show="viewing_home_framework&&$vuetify.breakpoint.smAndUp&&signed_in" v-on="on" icon small :accessible-label="side_by_side_button_label" @click.stop="viewer.side_by_side_editor_head_identifier=item.cfitem.identifier"><k-icon small>fas fa-code-compare</k-icon></k-btn></template><div class="text-center">Side-by-Side Comparison<br>to Archive [BETA]</div></k-tooltip>
								<k-tooltip bottom z-index="200"><template v-slot:activator="{on}"><k-btn v-show="viewing_home_framework&&$vuetify.breakpoint.smAndUp&&item_is_node" v-on="on" icon small :accessible-label="table_view_button_label" @click.stop="show_table_view"><k-icon small>fas fa-table-list</k-icon></k-btn></template>Table View</k-tooltip>
								<k-tooltip bottom z-index="200"><template v-slot:activator="{on}"><k-btn v-show="viewing_home_framework&&$vuetify.breakpoint.smAndUp" v-on="on" icon small :accessible-label="print_button_label" @click.stop="print_view"><k-icon small>fas fa-print</k-icon></k-btn></template>Print</k-tooltip>
								<k-tooltip bottom z-index="200"><template v-slot:activator="{on}"><k-btn v-on="on" icon small :accessible-label="qr_code_button_label" @click="show_qrcode=true"><k-icon small>fas fa-qrcode</k-icon></k-btn></template>QR Code</k-tooltip>
							</nobr></div>
						</div>
						<div v-if="!inline && !item_is_document && show_identifiers_in_tiles" class="k-case-tree-item-details-identifier text-center mt-2">
							<span class="k-case-tree-item-details-label">Identifier:</span> {{item.cfitem.identifier}}<CopyBtn :size="'small'" color="#666" :val="item.cfitem.identifier" class="ml-1"/>
						</div>

						<div v-if="item.cfitem.extensions.hideItemInUI" class="text-center mt-2 red--text text--darken-4"><b>ITEM AND CHILDREN ARE HIDDEN FOR END-USERS (visible only when editing)</b></div>

						<div v-if="custom_fields_html" class="text-center mt-2 pt-2" style="border-top:1px solid #bbb;" v-html="custom_fields_html"></div>

						<div v-if="!inline && !pinned_tile && !item_is_document && item_is_node && in_viewer_context && viewing_home_framework" class="k-case-tree-item-tile-search-children-div text-center mt-3" style="margin-bottom:-8px">
							<k-btn small :color="(limit_search_to_this_item&&search_limit_to_item)?'primary':'grey darken-3'" text class="k-tight-btn" @click="limit_search_to_this_item=!limit_search_to_this_item"><k-icon small class="mr-1">{{limit_search_to_this_item?'far fa-check-square':'fas fa-search'}}</k-icon> Search children of this item</k-btn>
						</div>
					</div>
				</div>
			</div>
		</div>

		<MirrorInfo v-if="mirror_info_showing" :lsdoc_identifier="framework_record.lsdoc_identifier" @mirror_info_cancel="mirror_info_showing=false" />
		<SatchelExport v-if="export_item_interface_showing" :item="item" :framework_record="framework_record" @dialog_cancel="export_item_interface_showing=false" />
		<k-dialog v-model="show_qrcode" max-width="600" persistentx scrollable :fullscreen="$vuetify.breakpoint.xs||$vuetify.breakpoint.sm"><k-card>
			<k-card-text>
				<div class="text-center mt-4" style="font-size:18px"><b>Scan this QR Code</b> to open this {{item_is_document?'framework':(item_type?item_type:'item')}} on your mobile device:</div>
				<div class="mt-4 d-flex justify-center"><qrcode-vue :value="item_link()" size="320" level="H" /></div>
			</k-card-text>
			<k-card-actions class="pa-2" style="border-top:1px solid #999">
				<k-spacer></k-spacer>
				<k-btn color="primary" small @click="show_qrcode=false"><k-icon small class="mr-2">fas fa-check</k-icon>Done</k-btn>
			</k-card-actions>
		</k-card></k-dialog>

	</div>
	<CFRubricModal 
		v-if="rubric_identifier_showing" 
		:initiating_cfitem="item.cfitem" 
		:rubric_identifier="rubric_identifier_showing" 
		:initial_rubric_component_identifier_showing="initial_rubric_component_identifier_showing" 
		:framework_record="framework_record"
		:association_type="rubric_association_type"
		@dialog_cancel="rubric_identifier_showing=null;initial_rubric_component_identifier_showing=null;rubric_association_type=null" 
	/>
</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import CASEItemAssociations from './CASEItemAssociations'
import CopyBtn from '../utilities/CopyBtn'
import TileComments from '../comments/TileComments'
import SatchelExport from '../edit/SatchelExport'
import MirrorInfo from './MirrorInfo'
import QrcodeVue from 'qrcode.vue'
import CFRubricModal from '@/components/rubric/CFRubricModal.vue'


export default {
	name: 'CASEItemTile',
	components: { CopyBtn, CASEItemAssociations, TileComments, SatchelExport, MirrorInfo, QrcodeVue, CFRubricModal},
	props: {
		item: { type: Object, required: true },
		home_framework_record: { type: Object, required: true },
		// this should be sent in if we're viewing an item that isn't part of the home framework record (i.e. it's from an associated framework)
		item_framework_record: { required: false, default() { return null }},
		// note that the tile is currently only shown in the "viewer context"
		viewer: { required: true },
		pinned_tile: { type: Boolean, required: false, default() { return false} },
		open_nodes_override: { required: false, default() { return null }},
		// if this is true, the tile is showing in the "expanded view", above the rest of the interface with its own history
		expanded_tile: { type: Boolean, required: false, default() { return false} },
	},
	data() { return {
		edit_actions_menu_showing: false,
		framework_create_menu_showing: false,
		framework_more_options_menu_showing: false,
		item_create_menu_showing: false,
		item_delete_menu_showing: false,
		exemplar_collapsed_local: false,
		show_notes_and_exemplar: false,
		export_item_interface_showing: false,
		license_text_showing: false,
		mirror_info_showing: false,
		show_qrcode: false,
		rubric_identifier_showing: null,
		initial_rubric_component_identifier_showing: null,
		rubric_association_type: null,
		view: 'form',

		// for controlling heights of extension fields
		fe_showing: {},
		fe_height: {},
		fe_style: {},
		fe_show_btn: {},
		min_field_height: 100,
	}},
	computed: {
		...mapState(['framework_records', 'association_type_labels', 'case_version_displayed', 'embedded_mode', 'embedded_mode_chooser', 'embedded_mode_chooser_outcomes_only', 'cureum_standards_tabbed', 'languages']),
		...mapGetters(['signed_in', 'show_identifiers_in_tiles']),
		show_associations() {
			return this.viewer.show_associations
			// we used to do this, but we don't want to show associations even in the expanded_tile if the user has chosen to hide associations, right?
			// return this.viewer.show_associations || this.expanded_tile
		},

		show_quick_align_btn() {
			if (this.inline) return false
			// if (!this.show_associations) return false

			// only show for resource frameworks
			if (!this.viewer.is_resource_framework) return false

			// you don't currently have to be editing to show this button, but you do have to be able to edit...
			// if (!this.editing_enabled) return false

			// these are the criteria for showing the edit btn in CASEFVToolbar
			if (this.viewer.embedded_mode) return false
			if (!this.viewer.user_can_edit) return false
			if (this.viewer.viewing_archive) return false

			// if we get to here return true
			return true
		},
		quick_align_btn_text() {
			// note that this will only be computed if show_quick_align_btn is true
			// if this is a resource item...
			if (this.$store.state.site_config.quick_align_resource_types.includes(this.item_type.toLowerCase())) {
				return 'Make Resource Alignments'
				
			// else it's a folder...
			} else {
				return 'Test Rosetta Align API'
			}
		},

		// tiles are always shown in the viewer context (at least for now)
		in_viewer_context() { return true },

		show_tile_comments_component() { 
			// if any of these are true, don't show comments
			if (this.embedded_mode) return false
			if (this.pinned_tile) return false
			if (!this.viewing_home_framework) return false

			// if user has clicked to show comments (lst.show_comments is true), show if the user is siend in or public_review is on
			if (this.$store.state.lst.show_comments) {
				if (this.signed_in) return true
				if (this.viewer.public_review_on) return true
			}

			return false
		},

		framework_record() {
			// if we received an item_framework_record, use it; otherwise use the home_framework_record
			if (this.item_framework_record) return this.item_framework_record
			return this.home_framework_record
		},
		ss_framework_data() { return this.framework_record.ss_framework_data },
		viewing_home_framework() { return this.framework_record == this.home_framework_record },

		basic_search_tree_key_hash() { return this.viewer.basic_search_tree_key_hash ? this.viewer.basic_search_tree_key_hash : {} },
		batch_edit_mode() { return this.viewer.batch_edit_mode },
		edited_node() { return this.viewer.edited_node },
		stats_mode() { return this.viewer.stats_mode },
		maximized() { return this.viewer.maximized },
		is_resource_framework() { return this.viewer.is_resource_framework },
		is_resource_item() { return U.is_resource_item(this.item.cfitem) },

		// the tile will be shown inline if the framework viewer isn't maximized, or if we're on a small screen
		inline() {
			if (this.expanded_tile) return false			// if tile is expanded, we're not inline
			if (this.viewer.wiki_mode_view) return false	// if in wiki_mode_view, we're not inline
			return !this.maximized || this.$vuetify.breakpoint.xs
		},

		is_sandbox() { return !empty(this.framework_record.ss_framework_data.sandboxOfIdentifier) },

		is_mirror() { return this.framework_record.ss_framework_data.is_mirror === 'yes' },

		is_derivative() { return this.viewer.is_derivative },
		derivative_original_framework_record() { return this.viewer.derivative_original_json },
		derivative_original_json() { return this.viewer.derivative_original_json },
		is_derived_item() {
			if (!this.is_derivative || !this.derivative_original_json) return false
			return this.derivative_original_json.CFItems.findIndex(x=>x.identifier == this.item.cfitem.identifier) > -1
		},
		framework_edit_menu_label() {
			return `Edit framework actions for ${this.item.cfitem.fullStatement || this.item.cfitem.humanCodingScheme || 'framework'}`
		},
		framework_edit_menu_content_id() {
			return `framework-edit-actions-${this.item.cfitem.identifier}`
		},
		framework_create_menu_content_id() {
			return `framework-create-actions-${this.item.cfitem.identifier}`
		},
		framework_more_options_menu_content_id() {
			return `framework-more-actions-${this.item.cfitem.identifier}`
		},
		item_edit_menu_label() {
			return `Edit item actions for ${this.item.cfitem.fullStatement || this.item.cfitem.humanCodingScheme || 'item'}`
		},
		item_edit_menu_content_id() {
			return `item-edit-actions-${this.item.cfitem.identifier}`
		},
		item_create_menu_content_id() {
			return `item-create-actions-${this.item.cfitem.identifier}`
		},
		item_delete_menu_content_id() {
			return `item-delete-actions-${this.item.cfitem.identifier}`
		},

		editing_enabled() { return this.viewer.editing_enabled },
		user_can_edit() { return this.viewer.user_can_edit },
		making_associations() { return this.viewer.current_editor && this.viewer.current_editor.make_association },	// this is pretty hackish

		show_chooser_btn() {
			if (this.embedded_mode && this.item_is_document) return false
			if (this.inline && this.embedded_mode_chooser && !this.item_is_document) {
				// if we get to here, show the chooser btn if embedded_mode_chooser_outcomes_only is off, or if this is an "outcome" item
				if (!this.embedded_mode_chooser_outcomes_only) return true
				if (this.item.is_outcome) return true
				return false
			}
		},

		show_edit_button() {
			// if this item's framework isn't the home framework, you can't edit the item
			if (this.item_framework_record && this.item_framework_record != this.home_framework_record) return false

			// if we're making associations, you can't edit
			if (this.making_associations) return false

			// show the edit button if editing is enabled, the user can edit, and we aren't currently waiting for import confirmation
			return this.editing_enabled && this.user_can_edit && this.viewer.new_imported_item_identifiers.length == 0 && this.viewer.updated_imported_item_identifiers.length == 0

		},

		item_is_document() { return empty(this.item.parent_node) },
		adoption_status_css_class() { if (this.item_is_document) return CFDocument.adoption_status_css_class(this.item.cfitem) },
		active_node() { return this.framework_record.active_node },
		open_nodes() {
			if (this.open_nodes_override) return this.open_nodes_override
			else return this.framework_record.open_nodes
		},
		pinned_items() { return this.framework_record.pinned_items },
		children_revealed() { return this.framework_record.children_revealed },
		last_clicked_node() { return this.framework_record.last_clicked_node },
		node_is_open() {
			return this.open_nodes[this.item.tree_key]
		},
		node_btn_style() {
			if (this.node_is_open) return 'transform:rotate(90deg)'
		},
		node_is_active() {
			return (this.active_node == this.item.tree_key)
		},
		item_is_pinned() {
			// TODO: account for the fact that an item can be in multiple places in the tree, and this node's item may already be pinned via another node
			return (this.pinned_items.findIndex(x=>x==this.item.tree_key) > -1)
		},
		item_is_leaf() {
			return this.item.children.length == 0
		},
		item_is_node() {
			return !this.item_is_leaf
		},
		item_is_last_clicked() {
			return this.last_clicked_node == this.item.tree_key
		},

		tracking_changes() {
			return vapp.case_tree_component && vapp.case_tree_component.tracking_changes
		},
		tracked_change_entities() {
			if (!this.tracking_changes) return {}
			return U.get_archive_comparison_entities(this.item.cfitem.identifier, vapp.case_tree_component.framework_record, vapp.case_tree_component.track_changes_framework_record)
		},
		show_tracked_changes() {
			// if we're tracking changes and there's an item on both sides, highlight the difference between current and archive; otherwise we just show what's in this.item
			return this.tracking_changes && this.tracked_change_entities.current.identifier && this.tracked_change_entities.archived.identifier
		},
		tracked_change_icon() {
			if (!this.tracking_changes) return ''
			return U.tracked_change_icon(this.tracked_change_entities)
		},
		item_title_for_accessibility() {
			return this.item?.cfitem?.title || this.item?.cfitem?.humanCodingScheme || (this.item_is_document ? 'framework' : 'item')
		},
		item_node_button_label() {
			if (this.item_is_document) {
				return this.is_resource_framework ? `Document resource framework: ${this.item_title_for_accessibility}` : `Framework document: ${this.item_title_for_accessibility}`
			}
			if (this.item.children.length > 0 && !this.is_resource_item) {
				return `Open item ${this.item_title_for_accessibility}`
			}
			if (this.is_resource_item) {
				return `Resource item ${this.item_title_for_accessibility}`
			}
			return `Item ${this.item_title_for_accessibility}`
		},
		tracked_change_button_label() {
			return `Show tracked changes for ${this.item_title_for_accessibility}`
		},
		edit_actions_button_label() {
			return this.item_is_document ? 'Open framework edit actions' : `Open edit actions for ${this.item_title_for_accessibility}`
		},
		item_metadata_button_label() {
			return `Show metadata for ${this.item_title_for_accessibility}`
		},
		side_by_side_button_label() {
			return `Show side-by-side comparison for ${this.item_title_for_accessibility}`
		},
		table_view_button_label() {
			return `Show table view for ${this.item_title_for_accessibility}`
		},
		print_button_label() {
			return `Print ${this.item_title_for_accessibility}`
		},
		qr_code_button_label() {
			return `Show QR code for ${this.item_title_for_accessibility}`
		},
		track_changes_fields() { return this.$store.state.lst.track_changes_fields },

		language_display() {
			if (empty(this.item.cfitem.language)) return ''
			let o = this.languages.find(x=>x.value == this.item.cfitem.language)
			return o ? o.text : this.item.cfitem.language
		},
		item_type() {
			// allow for the fact that an item's type can be in either CFItemType or CFItemTypeURI.title
			return U.item_type_string(this.item.cfitem)
		},
		cfdocument_subject() {
			if (!this.item_is_document) return ''

			// this is supposed to always come in as an array, but sometimes it's a string
			if (empty(this.item.cfitem.subject)) return ''
			if ($.isArray(this.item.cfitem.subject)) return this.item.cfitem.subject.join(', ')
			return this.item.cfitem.subject
		},
		license_data() {
			let o = object_copy(U.get_license_json(this.framework_record))
			if (!empty(o.licenseText)) 
				o.marked_licenseText = markedInline(o.licenseText, false).replace(/<a /, '<a target="blank" ')
			return o
			// note that this.license_data.licenseText will resolve to either null/undefined or the licenseText value
		},
		license_title() {
			if (this.item.cfitem.licenseURI) {
				// try to get the title from the license_data (even though it should really be identical with the title in licenseURI)
				if (this.license_data.title) return this.license_data.title
				else return this.item.cfitem.licenseURI.title
			}
		},
		human_coding_scheme() {
			if (this.show_tracked_changes && this.track_changes_fields.humanCodingScheme && this.track_changes_fields.highlight_text_diffs) {
				let s = this.tracked_change_entities.current.humanCodingScheme ?? ''
				let archived = this.tracked_change_entities.archived.humanCodingScheme ?? ''
				let diff = U.diff_string(archived, s)
				return (this.in_viewer_context) ? diff.n : diff.o

			} else {
				return this.highlight_search_terms(this.item.cfitem.humanCodingScheme, 'humanCodingScheme')
			}
		},
		marked_full_statement() {
			// if we need mathjax for latex translation and it's not ready, return; the computed will re-run once mathjax is ready
			if (this.$store.state.mathjax_initialized == 'started') return ''

			if (this.show_tracked_changes && this.track_changes_fields.fullStatement && this.track_changes_fields.highlight_text_diffs) {
				let s, archived

				if (this.item_is_document) {
					s = this.tracked_change_entities.current.title
					archived = this.tracked_change_entities.archived.title
				} else {
					// preserve latex here; then do diff_string, then render latex below
					s = marked(U.preserve_latex(this.tracked_change_entities.current.fullStatement))
					archived = marked(U.preserve_latex(this.tracked_change_entities.archived.fullStatement))
				}

				let diff = U.diff_string(archived, s, 'preserve_tags')
				// show the new value if we're on the left side, or the old value on the right
				diff = (this.in_viewer_context) ? diff.n : diff.o

				return U.render_latex(U.preserve_latex_reverse(diff))

			} else {
				// for the document, return the doc title
				if (this.item_is_document) return this.item.cfitem.title
				// return U.render_latex(this.item.cfitem.fullStatement)

				let s = U.marked_latex(this.item.cfitem.fullStatement, false, this.item.cfitem.extensions.latex_alt_text)
				return this.highlight_search_terms(s, 'fullStatement')
			}
		},
		marked_notes() {
			// if we need mathjax for latex translation and it's not ready, return; the computed will re-run once mathjax is ready
			if (this.$store.state.mathjax_initialized == 'started') return ''

			if (!this.item.cfitem.notes) return ''
			let s

			if (this.show_tracked_changes && this.track_changes_fields.notes && this.track_changes_fields.highlight_text_diffs) {
				// preserve latex here; then do diff_string, then render latex below
				s = marked(U.preserve_latex(this.tracked_change_entities.current.notes))
				let archived = marked(U.preserve_latex(this.tracked_change_entities.archived.notes))

				let diff = U.diff_string(archived, s, 'preserve_tags')
				// show the new value if we're on the left side, or the old value on the right
				s = (this.in_viewer_context) ? diff.n : diff.o
				s = U.render_latex(U.preserve_latex_reverse(s))

			} else {
				s = U.marked_latex(this.item.cfitem.notes, false, this.item.cfitem.extensions.latex_alt_text)
				s = this.highlight_search_terms(s, 'notes')
			}

			// make sure all links open in a new window (though notes really shouldn't have links; note that for exemplars froala should ensure _blank is included)
			s = s.replace(/<a /g, '<a target="_blank" ')

			return s	
		},
		marked_exemplar() {
			// if we need mathjax for latex translation and it's not ready, return; the computed will re-run once mathjax is ready
			if (this.$store.state.mathjax_initialized == 'started') return ''

			// if we're not showing vext CASE, don't show exemplars
			if (this.case_version_displayed != 'vext') return ''
			if (!this.item.cfitem.extensions.supplementalNotes) return ''
			let exs
			if (this.show_tracked_changes && this.track_changes_fields.supplementalNotes && this.track_changes_fields.highlight_text_diffs) {
				// note: tracked_change_entities.current and tracked_change_entities.archived will have supplementalNotes as direct fields, not part of extensions
				// preserve latex here; then do diff_string, then render latex below
				exs = U.preserve_latex(this.tracked_change_entities.current.supplementalNotes)
				if (exs.search(/<\w+[^<]*>/) == -1) exs = marked(exs)

				let archived = U.preserve_latex(this.tracked_change_entities.archived.supplementalNotes)
				if (archived.search(/<\w+[^<]*>/) == -1) archived = marked(archived)

				let diff = U.diff_string(archived, exs, 'preserve_tags')
				// show the new value if we're on the left side, or the old value on the right
				exs = (this.in_viewer_context) ? diff.n : diff.o
				exs = U.render_latex(U.preserve_latex_reverse(exs))

			} else {
				// note that examplars can either use html or markdown; use marked if we don't have any html tags
				// also note that if the author uses latex, they shouldn't also try to use markdown, because the latex renderer will render the latex as html, so marked() won't be run here
				exs = this.item.cfitem.extensions.supplementalNotes

				// do wiki_variable_substitutions if necessary
				if (this.viewer.wiki_mode_view) exs = this.viewer.wiki_variable_substitutions(exs)

				if (exs.search(/<\w+[^<]*>/) == -1) exs = U.marked_latex(exs)
				else exs = U.render_latex(exs)
				exs = this.highlight_search_terms(exs, 'exemplar')
			}

			// if exemplar includes <hr>s, convert the line after each <hr> to an expandable div
			let arr = exs.split('<hr>')
			if (arr.length == 1) {
				// no blocks; just return exs
				return exs

			} else {
				// start with whatever was in arr[0] (which might be an empty string)
				let html = arr[0].replace(/(<br>)+$/, '')

				// for each additional block
				for (let i = 1; i < arr.length; ++i) {
					// try to extract the first line, which is a little tricky because it might be a paragraph, or it might be a blank line separated by a <br> or a <ol> or <ul>
					let header, footer
					if (arr[i].search(/^\s*<p>(.*?)<\/p>([\s\S]*)/) > -1) {
						header = RegExp.$1
						footer = RegExp.$2
					} else if (arr[i].search(/^(.*?)((<br|<ol|<ul)[\s\S]*)/) > -1) {
						header = RegExp.$1
						footer = RegExp.$2
					}

					if (header && footer) {
						// remove leading <br> from footer if there (that br would be the end of the header line)
						footer = footer.replace(/^<br>/, '')

						let block_id = U.new_uuid()
						html += sr('<div class="k-exemplar-block-header" data-header-id="$1" data-block-showing="yes"><i class="fas fa-caret-right"></i> $2</div><div class="k-exemplar-block-body" data-block-id="$1">$3</div>', block_id, header, footer)

						this.$nextTick(x=>{
							$('[data-header-id=' + block_id + ']').click(function() {
								let jq = $(this)
								let block_id = jq.attr('data-header-id')
								let showing = jq.attr('data-block-showing')
								if (showing == 'no') {
									$('[data-block-id=' + block_id + ']').slideDown(100)
									jq.find('.fas').removeClass('fa-caret-right').addClass('fa-caret-down')
									jq.attr('data-block-showing', 'yes')
								} else {
									$('[data-block-id=' + block_id + ']').slideUp(100)
									jq.find('.fas').removeClass('fa-caret-down').addClass('fa-caret-right')
									jq.attr('data-block-showing', 'no')
								}
							})
						})

					} else {
						html += sr('<div class="k-exemplar-block-body-no-header">$1</div>', arr[i])
					}
				}

				return html
			}
		},
		featured_extensions() {
			// if any extensions are marked in config as 'featured', we show them above the notes
			let arr = []

			for (let key in this.custom_fields) {
				let field = this.custom_fields[key]
				let val = this.item.cfitem.extensions[key]
				// if this item's type doesn't match the field's item types, don't show it
				if (field.applicableItemTypes && field.applicableItemTypes.length > 0 && !field.applicableItemTypes.includes(this.item_type)) continue

				// only show 'featured' fields here
				if (field.always_display != 'featured') continue
				// ? also only show "long_string" fields; that type is translated as follows in case_data_structures
				// for now, show all featured values using this construct...
				// if (field.edit_ui != 'textarea') continue

				let o = {
					key: key,
					display_key: field.display_key?field.display_key:key,
				}

				// if the value is empty don't show it; otherwise format
				if ($.isArray(val)) {
					if (val.length == 0) continue
					o.copy_val = val.join(', ')
					o.display_val = o.copy_val
				} else {
					if (empty(val)) continue
					o.copy_val = val
					// if field is a string (default)
					if (field.type == 'string' || empty(field.type)) {
						// if it looks like a url, show as a link
						if (val.search(/^https:\/\//) == 0) o.display_val = `<a href="${val}" target="_blank">${val}</a>`
						// else put it through marked_latex
						else o.display_val = U.marked_latex(val)
					}
				}
				arr.push(o)
			}

			// note that this.get_field_heights() will be called by the item watcher

			return arr
		},
		exemplar_collapsible() { return this.marked_exemplar.indexOf('k-exemplar-block-header') > -1 },
		education_level_display() {
			let low = this.item.cfitem.educationLevel[0]
			let high = this.item.cfitem.educationLevel[this.item.cfitem.educationLevel.length-1]
			if (low == high) return low
			else return sr('$1-$2', low, high)
			// this overlooks the possibility of education levels that aren't a range, but that's very unlikely
		},
		adoption_status_display_value() { return CFDocument.adoption_status_display_value(this.item.cfitem.adoptionStatus) },

		// this gets toggled between true and false when the user clicks the btn to limit searches to this item
		limit_search_to_this_item: {
			// see CASEFVSearchMixin for other places where we use lst to track search preferences for a framework
			get() {
				// get the current value for search_item_for_limit
				let search_item_for_limit = 0
				let s = this.$store.state.lst.search_item_for_limit
				if (s) {
					let o = JSON.parse(s)
					if (o[this.framework_record.lsdoc_identifier]) search_item_for_limit = o[this.framework_record.lsdoc_identifier]
				}

				// return whether or not search_item_for_limit matches this item's node
				return (search_item_for_limit == this.item.tree_key)
			},
			set(val) {
				// when the button is clicked, we toggle the value of limit_search_to_this_item so that this fn will be called.
				// however, clicking the btn always indicates that you *want* to limit searches by this item, so...
				// set lst.search_item_for_limit for this framework to this item's tree_key, and set lst.search_limit_to_item to true
				this.viewer.search_item_for_limit = this.item.tree_key
				this.viewer.search_limit_to_item = true
				// note that the computed setter for search_limit_to_item will reveal the search panel

				// if we're expanded, de-expand
				if (this.expanded_tile) this.$emit('full_screen_compressed')
			},
		},
		search_limit_to_item() {
			let s = this.$store.state.lst.search_limit_to_item
			if (s) {
				let o = JSON.parse(s)
				return (o[this.framework_record.lsdoc_identifier]) ? true : false
			} else {
				return false
			}
		},
		item_is_from_home_framework() {
			// if the item is in cfo.cfitems, it's from the home framework
			if (!empty(this.home_framework_record.cfo.cfitems[this.item.cfitem.identifier])) return true
			// else if it's a document and it's the home framework document, it's from the home framework
			if (this.item_is_document && this.item.cfitem.identifier == this.home_framework_record.lsdoc_identifier) return true
			// else it isn't from the home framework
			return false
		},
		item_framework_class() {
			if (!this.item_framework_record) return ''
			const framework_color = U.framework_color(this.item_framework_record.lsdoc_identifier)
			if (!isNaN(framework_color)) return 'k-framework-color-' + framework_color + '-dark'
			return ''
		},
		item_framework_style() {
			return U.framework_color_object(this.framework_record.lsdoc_identifier, 'dark')

		},
		item_framework_description() {
			if (!this.item_framework_record) return '<i>This item is from another framework.</i>'
			return sr('From framework: <b>$1</b>', this.item_framework_record.json.CFDocument.title)
		},
		user_can_admin() {
			return vapp.is_granted('admin_framework', this.framework_record.lsdoc_identifier)
		},

		// for embedded mode
		selected_items() { return this.viewer.selected_items },
		item_is_selected() { 
			if (!this.selected_items) return false
			// select on the basis of selected_nodes, which is calculated in this.viewer
			return this.viewer.selected_nodes.includes(this.item)
		},
		selected_item_icon_style() {
			if (this.item_is_document || !this.item_is_selected) return 'display:none'
			let s = 'font-size:11px!important; margin-left:0px; margin-top:4px; margin-right:2px;'
			// let s = 'font-size:16px!important; margin-left:2px; margin-top:1px; margin-right:2px;'
			// if (this.item_is_document) return s + 'visibility:hidden;'
			// if (!this.item_is_selected) return s + 'visibility:hidden;'
			return s + 'opacity:0.7;'
		},
		custom_fields() {
			if (this.item_is_document) return window.CASE_Custom_Extension_Fields.CFDocument ?? null
			else return window.CASE_Custom_Extension_Fields.CFItem ?? null
		},
		custom_fields_html() {
			// no custom fields to show if we're inline, or if there are no CFItem custom fields
			if (!this.custom_fields || this.inline) return ''

			// go through each custom field...
			let s = ''
			for (let key in this.custom_fields) {
				let field = this.custom_fields[key]
				let val = this.item.cfitem.extensions[key]
				// if this item's type doesn't match the field's item types, don't show it
				if (field.applicableItemTypes && field.applicableItemTypes.length > 0 && !field.applicableItemTypes.includes(this.item_type)) continue
				
				// if show_identifiers_in_tiles is false and field.always_display isn't 'no', don't show it
				if (!this.show_identifiers_in_tiles && field.always_display == 'no') continue

				// don't show 'featured' extensions here, because we show featured extensions separately 
				if (field.always_display == 'featured') continue
				// also don't show 'never' extensions here; this is used for potentially very long strings that we might not have room for
				if (field.always_display == 'never') continue

				// if the value is empty don't show it; otherwise format and add to s
				if ($.isArray(val)) {
					if (val.length == 0) continue
					s += `<div class="d-inline py-1 px-2"><span class="k-case-tree-item-details-label">${field.display_key?field.display_key:key}:</span> <span>${val.join(', ')}</span></div>`
				} else {
					if (empty(val)) continue

					// if field is a string (default)
					if (field.type == 'string' || empty(field.type)) {
						// if it looks like a url, show as a link
						if (val.search(/^https:\/\//) == 0) val = `<a href="${val}" target="_blank">${val}</a>`
					}

					s += `<div class="d-inline py-1 px-2"><span class="k-case-tree-item-details-label">${field.display_key?field.display_key:key}:</span> <span>${val}</span></div>`
				}
			}
			return s
		},
		item_has_rubric() {
			// we count this cfitem as having a rubric if it has any association to a rubric or a rubric sub-element;
			// as of now, at least, we don't support multiple rubric associations for the same item
			let arr = this.framework_record.cfo.associations_hash[this.item.cfitem.identifier]
			if (!arr) return false
			return (arr.findIndex(x=>U.is_rubric_association(x)) > -1) 
		},
		progression_table_available() { return U.progression_table_available(this.framework_record, this.item) },

		// return true if we should be showing the div for aligned resources
		show_aligned_resources_info() {
			// we only do this in cureum_standards_tabbed mode, or if show_asset_counts_in_item_tiles is set to true
			if (this.cureum_standards_tabbed || this.$store.state.show_asset_counts_in_item_tiles) {
				// and only show the btn if we have assets available for this item (or its children)
				if (this.item_aligned_asset_count > 0 || this.child_aligned_asset_count > 0) return true
			}
			return false
		},
		// number of aligned assets to this item itself
		item_aligned_asset_count() {
			let ac = this.$store.state.asset_counts[this.framework_record.lsdoc_identifier]
			if (empty(ac)) return 0
			return ac[this.item.cfitem.identifier] ?? 0
		},
		// number of aligned assets to this item's descendents
		child_aligned_asset_count() {
			let ac = this.$store.state.asset_counts[this.framework_record.lsdoc_identifier]
			if (empty(ac)) return 0

			// recursively count alignments in this item + child items, then subtract this item's count
			const count_em_all = (item) => {
				let n = ac[item.cfitem.identifier] ?? 0
				for (let child of item.children) {
					n += count_em_all(child)
				}
				return n ?? 0
			}
			return count_em_all(this.item) - this.item_aligned_asset_count
		},
		total_aligned_asset_count() { return this.item_aligned_asset_count + this.child_aligned_asset_count },
		aligned_item_btn_tooltip() {
			let item_type_label = U.item_type_string(this.item.cfitem) || 'framework item'

			// show an appropriate tooltip for the aligned items count...
			let s = ''
			if (this.item_aligned_asset_count > 0) {
				s = `${this.item_aligned_asset_count} ${U.ps('Content Item is', this.item_aligned_asset_count, 'Content Items are')} aligned directly to this ${item_type_label}.`
			}
			if (this.child_aligned_asset_count > 0) {
				if (s) s += '<br>'
				s += `Up to ${this.child_aligned_asset_count} ${U.ps('Content Item is', this.child_aligned_asset_count, 'Content Items are')} aligned to “descendents” of this ${item_type_label}.`
			}
			return s
		},
	},
	watch: {
		item: {
			immediate: true, deep:true, handler() {
				// update field heights when item is updated; delay a bit to let things settle down
				setTimeout(x=>this.get_field_heights(), 100)

				// if this is a pinned tile, always collapse the exemplar to start
				if (this.pinned_tile) {
					this.$nextTick(x => this.toggle_exemplar(true))
				} else {
					// else always start with the lst value of exemplar_collapsed
					this.$nextTick(x => this.toggle_exemplar(this.$store.state.lst.exemplar_collapsed))
				}
			}
		},
		'$vuetify.breakpoint.width'() {
			// update field heights when page width changes
			this.get_field_heights()
		}
	},
	created() {
		
	},
	mounted() {
		vapp.case_item_tile = this
	},
	methods: {
		create_child_rubric() {
			this.rubric_association_type = 'isChildOf'
			console.log('create_child_rubric')
			this.create_rubric()
		},
		create_association_rubric() {
			this.rubric_association_type = 'ext:hasRubric'
			console.log('create_association_rubric')
			this.create_rubric()
		},
		choose_rubric_type() {
			vapp.$prompt({
				title: 'Choose Rubric Type',
				text: 'You can either create a rubric as a child of this item, or as an association to this item.',
				promptType: 'select',
				// allowing for full-size images is too dangerous -- files could be *huge*; to allow it, add {value:'full', text: 'Full-Size'}
				selectOptions: [
					{value:'child', text: 'Child of Item'},
					{value:'association', text: 'Association to Item'},
				],
				initialValue: 'child',
				focusBtn: true,
				acceptText: 'Select',	// focus on the accept btn when dialog is rendered
			}).then(rubric_type => {
				if (rubric_type) {
					// if the user clicked "Select", rubric_type will be the value of the selected option
					if (rubric_type == 'child') this.create_child_rubric()
					else if (rubric_type == 'association') this.create_association_rubric()
				}
			})
		},
		item_outer_css() {
			let s = ''

			if (this.expanded_tile) {
				s += ' k-case-tree-item-tile-outer-full-screen'
			} else {
				if (this.item_is_last_clicked) {
					s += ' k-case-tree-item-tile-last-clicked'
				}

				if (this.pinned_items.length > 0 && !this.pinned_tile) {
					s += ' k-case-tree-item-tile-active-with-pinned-items'
				}

				if (this.inline) {
					s += ' k-case-tree-item-tile-outer-inline'
				}

				// if the item has supplementalNotes, allow for more horizontal space
				if (!empty(this.marked_exemplar)) {
					s += ' k-case-tree-item-tile-outer-has-supp-notes'
				}
			}

			// apply color coding by item type, if user hasn't turned it off
			if (this.inline && this.$store.state.lst.show_color_coded_item_types) {
				s += ' k-case-tree-item-type-color'
				let item_type_level = this.framework_record.cfo.item_type_levels.find(x=>x.item_type == U.item_type_string(this.item.cfitem))
				if (item_type_level) {
					s += (' k-case-tree-item-type-color-' + item_type_level.level_index)
				}
			}

			if (!this.ss_framework_data.ignore_status_dates) {
				// add style for items that haven't yet reached statusStartDate, and/or have passed statusEndDate (both shouldn't be true, but that technically could happen)
				// note that here we add the style on outer; in CASEItem we add the style in inner
				// ignore dates < 2010; such dates almost certainly reflect incorrect usage of the fields
				if (!empty(this.item.cfitem.statusStartDate) && this.item.cfitem.statusStartDate > '2010') {
					if (this.$store.state.today < this.item.cfitem.statusStartDate) s += ' k-case-tree-item-not-yet-adopted'
				}
				if (!empty(this.item.cfitem.statusEndDate) && this.item.cfitem.statusEndDate > '2010') {
					if (this.$store.state.today >= this.item.cfitem.statusEndDate) s += ' k-case-tree-item-no-longer-adopted'
					else if (this.item.cfitem.statusEndDate) s += ' k-case-tree-item-scheduled-no-longer-adopted'
				}
			}

			return s
		},

		item_css(hover) {
			// most of these don't do anything as of now (exception: k-case-tree-item-tile-selected)
			let s = ''
			if (!empty(this.edited_node) && this.edited_node.tree_key == this.item.tree_key) {
				s += ' k-case-tree-item-tile-being-edited'
			}

			if (this.basic_search_tree_key_hash[this.item.tree_key]) {
				s += ' k-case-tree-item-tile-search-match'
			}

			if (this.item.cfitem.stats.duplicate_hovered) {
				s += ' k-case-tree-item-tile-duplicate-hovered'
			}

			if (this.item_is_document) {
				s += ' k-case-tree-item-document'
			}

			if (this.selected_items && this.item_is_selected) {
				s += ' k-case-tree-item-tile-selected'
			}

			if (this.item_is_leaf) {
				s += ' k-case-tree-item-tile-leaf'
			} else {
				s += ' k-case-tree-item-tile-node'
			}

			return s
		},

		chooser_style(hover) {
			return 'font-size:18px'
			if (this.item.cat) return 'font-size:16px'	// current association type
			else return 'font-size:20px'
		},
		chooser_icon(hover) {
			// marker for already-aligned item in resource alignment mode
			if (this.item.cat) return 'fas fa-check'

			// return check-circle if we're in the viewer context and this is the framework's chosen_node
			if (this.in_viewer_context && this.framework_record.chosen_node == this.item.tree_key) return 'fas fa-square-check'
			// or node_is_chosen_local is set to true
			if (this.node_is_chosen_local) return 'fas fa-square-check'

			// if we have chosen_items and this item's identifier is among them...
			// if we have chosen_items or selected_items and this item's identifier is among them...
			if (this.chosen_items?.find(x=>x==this.item.cfitem.identifier) || this.selected_items?.find(x=>x==this.item.cfitem.identifier)) {
				// if hovering, return an 'x', because clicking it will remove the association; else return check
				if (hover) return 'fas fa-square-xmark'
				else return 'fas fa-square-check'
			}

			// if we get to here show blank square
			return 'far fa-square'
		},
		chooser_color(hover) {
			// green if we're in the viewer context and this is the framework's chosen_node
			if (this.in_viewer_context && this.framework_record.chosen_node == this.item.tree_key) return 'green'
			// green if node_is_chosen_local is set to true
			if (this.node_is_chosen_local) return 'green'
			// green if item.cat is true
			if (this.item.cat) return 'green'

			// if we have selected_items or chosen_items and this item's identifier is among them...
			if (this.chosen_items?.find(x=>x==this.item.cfitem.identifier) || this.selected_items?.find(x=>x==this.item.cfitem.identifier)) {
				// if hovering, return red, because clicking it will remove the association; otherwise return orange
				if (hover) return 'red'
				else return 'orange'
			}

			// if we get to here, green if hovering or gray otherwise
			if (hover) return 'green'
			else return '#ccc'
		},

		marked(s) {
			return marked(s)
		},

		highlight_search_terms(s, field) {
			// if we have a highlight_search_terms fn in viewer
			if (this.viewer.highlight_search_terms) {
				// and if field is included in viewer.search_field_types
				if (this.viewer.search_field_types.includes(field)) {
					// then highlight
					s = this.viewer.highlight_search_terms(s, this.item.tree_key)
				}
			}

			return s
		},

		tree_statement_for_copy() {
			// for the document, return the doc title
			if (empty(this.item.parent_node)) return this.item.cfitem.title

			let s = this.item.cfitem.fullStatement
			if (this.item.cfitem.humanCodingScheme) s = this.item.cfitem.humanCodingScheme + ' ' + s
			return s
		},

		mouseover() { this.$store.commit('set', [this.framework_record, 'hovered_tile', this.item.tree_key])},
		mouseout() { this.$store.commit('set', [this.framework_record, 'hovered_tile', ''])},

		close_tile() {
			// clear hovered_tile
			this.$nextTick(x=>this.$store.commit('set', [this.framework_record, 'hovered_tile', '']))

			// if pinned_tile, unpin the item
			if (this.pinned_tile) {
				this.toggle_pin()
				return
			}

			// clear the active node and starting_lsitem_identifier
			this.viewer.make_node_active('', true)

			// set last_clicked_node, to help the user remember what they last clicked
			this.$store.commit('set', [this.framework_record, 'last_clicked_node', this.item.tree_key])
		},

		show_chooser_fn_clicked(evt) {
			if (this.in_viewer_context) this.viewer.show_chooser_fn(this, this.item, evt)
		},

		tracked_change_clicked() {
			setTimeout(x=>this.viewer.show_archived_item(this.item), 100)
		},

		item_clicked() {
			if (!this.viewer.lsdoc_identifier) {
				return
			}

			if (this.pinned_tile) {
				this.viewer.make_node_parents_open(this.item.tree_key)
				this.viewer.make_node_open(this.item.tree_key)
				this.viewer.make_node_active(this.item.tree_key, true)
				this.$store.commit('set', [this.framework_record, 'last_clicked_node', this.item.tree_key])

			// when showing the tile inline, close it on click
			} else if (this.inline) {
				this.close_tile()
			}
		},

		toggle_pin() {
			if (this.item_is_pinned) {
				this.$store.commit('splice_from_array', [this.framework_record.pinned_items, this.item.tree_key])
			} else {
				this.$store.commit('add_to_array', [this.framework_record.pinned_items, this.item.tree_key])
			}

			// store pinned items in localstorage
			// (note that code in CASETree also deals with this lst property)
			let s = this.$store.state.lst.pinned_items
			let o = (s) ? JSON.parse(s) : {}
			o[this.framework_record.lsdoc_identifier] = this.framework_record.pinned_items
			this.$store.commit('lst_set', ['pinned_items', JSON.stringify(o)])
		},

		create_rubric() {
			// to create a new rubric, we just generate a new uuid for the rubric to be created; the rubric modal will show the editor and allow it to be created
			this.rubric_identifier_showing = U.new_uuid()
			this.initial_rubric_component_identifier_showing = null
			this.edit_actions_menu_showing = false

			// if we're showing in the expanded view, hide the expanded view so the editor can be viewed
			if (this.expanded_tile) this.$emit('full_screen_compressed')
		},

		edit_item(action) {
			this.edit_actions_menu_showing = false
			this.viewer.edit_item(this.item, action)

			// if we're showing in the expanded view, hide the expanded view so the editor can be viewed
			if (this.expanded_tile) this.$emit('full_screen_compressed')
		},
		//made async so we can await the stamp reminder dialog
		async edit_document(action) {
			this.edit_actions_menu_showing = false
			if (action === 'show_csv_import_interface') {
				//await and pass force_show=true to make sure the dialog shows even with no changes
				await this.viewer.check_for_stamp_reminder_dialog(true)
			}
			this.viewer.edit_document(action)
		},
		more_info() {
			if (this.expanded_tile) this.$emit('more_info')
			else this.viewer.more_info(this.item)
		},
		print_view() {
			this.viewer.print_view(this.item)
		},
		show_table_view() {
			this.viewer.table_mode_start_node = this.item
			this.viewer.viewer_table_mode = 'items'
			this.viewer.viewer_mode = 'table'
		},

		show_qr_code() {

		},

		viewer_fn(fn_name, evt) {
			this.edit_actions_menu_showing = false
			this.viewer[fn_name](evt)
		},

		toggle_make_associations() {
			let node
			if (!this.item_is_document) node = this.item
			const restore_focus_element = this.get_edit_actions_focus_origin()
			this.close_edit_action_menus()
			this.$nextTick(() => {
				window.requestAnimationFrame(() => {
					this.viewer.toggle_make_associations(node, restore_focus_element)
				})
			})
		},
		close_edit_action_menus() {
			this.edit_actions_menu_showing = false
			this.framework_create_menu_showing = false
			this.framework_more_options_menu_showing = false
			this.item_create_menu_showing = false
			this.item_delete_menu_showing = false
		},
		get_edit_actions_focus_origin() {
			return this.$refs.item_edit_actions_menu?.activatorElement
				|| this.$refs.framework_edit_actions_menu?.activatorElement
				|| (typeof document !== 'undefined' ? document.activeElement : null)
		},

		initiate_resource_search() {
			// if we're in cureum_standards_tabbed mode, initiate the show_resource_search postmessage
			if (this.cureum_standards_tabbed) {
				vapp.pm_send('show_resource_search', {
					framework_identifier: this.framework_record.lsdoc_identifier, 
					item_identifier: this.item.cfitem.identifier
				})

			} else {
				// else we're in the cureum search "browse standards" dialog, so do the same thing as clicking the item checkbox
				this.show_chooser_fn_clicked()
			}
		},

		toggle_exemplar(new_collapsed_value) {
			// if expanded_tile is true, we always have the exemplar expanded
			if (this.expanded_tile) return

			// set or toggle exemplar_collapsed_local, then set to_show to 'yes' or 'no' depending on current value
			if (new_collapsed_value === false || new_collapsed_value === true) this.exemplar_collapsed_local = new_collapsed_value
			else this.exemplar_collapsed_local = !this.exemplar_collapsed_local

			// if we're not showing in a pinned tile, store value of exemplar_collapsed to lst
			if (!this.pinned_tile) this.$store.commit('lst_set', ['exemplar_collapsed', this.exemplar_collapsed_local])

			let to_show = (this.exemplar_collapsed_local) ? 'no' : 'yes'

			$(this.$el).find('[data-header-id]').each(function() {
				let jq = $(this)
				let block_id = jq.attr('data-header-id')
				if (to_show == 'yes') {
					$('[data-block-id=' + block_id + ']').slideDown(100)
					jq.find('.fas').removeClass('fa-caret-right').addClass('fa-caret-down')
					jq.attr('data-block-showing', 'yes')
				} else {
					$('[data-block-id=' + block_id + ']').slideUp(100)
					jq.find('.fas').removeClass('fa-caret-down').addClass('fa-caret-right')
					jq.attr('data-block-showing', 'no')
				}
			})
		},

		expand_tile() {
			this.viewer.show_expanded_item(this.item, this.framework_record)
		},

		update_rest_api() {
			U.loading_start()
			U.ajax('sync_case_api', {framework_identifiers: [this.framework_record.lsdoc_identifier]}, result=>{
				U.loading_stop()
				this.$alert('CASE REST API data updated. (Note that if you don’t do this manually, an automated service runs every 15 minutes to update CASE REST API data for any frameworks that have been changed.)')
			})
		},

		// for qrcode
		item_link() {
			return window.location.toString()
		},

		show_progression_table() { vapp.case_tree_component.show_progression_table(this.framework_record, this.item) },

		show_rubric_from_association(assoc) {
			// note: we assume here that the rubric is located in the framework we're viewing
			let rubric = U.get_rubric_from_association(assoc, this.framework_record)
			if (!rubric) {
				this.$alert('Couldn’t find rubric...')
				return
			}
			this.rubric_identifier_showing = rubric.identifier
			// set initial_rubric_component_identifier_showing to the rubric component (a rubric, criterion, or level) that was clicked on
			this.initial_rubric_component_identifier_showing = assoc.destinationNodeURI.identifier
		},

		copy_wiki_link() {
			// PW 8/10/2025: we used to add the wiki item identifier (the humanCodingScheme) to the URL here, but this 
			// a) screws things up for the Sparkl user guide, and b) doesn't really improve the experience for the Satchel user guide.
			// let link = document.location.toString() + '?help=' + this.item.cfitem.humanCodingScheme

			// PW 6/21/2026: now we add "?embedded" to the link, which hides the top banner of the window, so the user doesn't see things like the signin button
			let link = document.location.toString() + '?embedded'
			U.copy_to_clipboard(link)
			this.$inform('User Guide Link copied to clipboard')
		},

		// we use this if the item has resources in child items; show the first child item
		move_to_first_child() {
			// this will only be called if the item has at least one child
			const new_node = this.item.children[0]
			this.viewer.make_node_parents_open(new_node.tree_key)
			this.viewer.make_node_open(new_node.tree_key)
			this.viewer.make_node_active(new_node.tree_key, true)
			this.$store.commit('set', [this.framework_record, 'last_clicked_node', new_node.tree_key])
		},

		fek(key) {
			return `${this.item.cfitem.identifier}--${key}`
		},

		get_field_heights() {
			if (!$(this.$el).is(':visible')) {
				// console.warn('get_field_heights: not visible')
				clearTimeout(this.gfh_timeout)
				this.gfh_timeout = setTimeout(x=>this.get_field_heights(), 100)
				return
			}
			// console.warn('get_field_heights: visible')

			let get_field_height = (key) => {
				let fekey = this.fek(key)
				this.$set(this.fe_style, fekey, 'height:auto; visibility:hidden;')
				setTimeout(x=>{
					let h = $(this.$el).find(`[data-extension-inner="${fekey}"]`).height()
					this.$set(this.fe_height, fekey, h)

					if (this.fe_showing[fekey] !== true) {
						this.$set(this.fe_showing, fekey, false)
					}

					if (h < this.min_field_height) {
						this.$set(this.fe_style, fekey, `height:${h + 0}px;`)
						this.$set(this.fe_show_btn, fekey, false)

					} else if (this.fe_showing[fekey]) {
						this.$set(this.fe_style, fekey, `height:${h + 0}px;`)
						this.$set(this.fe_show_btn, fekey, true)

					} else {
						this.$set(this.fe_style, fekey, `height:${this.min_field_height}px; overflow:hidden;`)
						this.$set(this.fe_show_btn, fekey, true)
					}

					// console.warn(`${fekey} height: ${h} / style: ${this.fe_style[fekey]}`)
				}, 0)
			}

			// notes
			if (!empty(this.marked_notes)) get_field_height('notes')
			// supp info if it isn't separately collapsible
			if (!empty(this.marked_exemplar) && !this.exemplar_collapsible && !this.viewer.wiki_mode_view) get_field_height('exemplar')
			// document description
			if (!empty(this.item.cfitem.description)) get_field_height('doc_description')

			// featured custom fields
			for (let key in this.custom_fields) {
				let field = this.custom_fields[key]
				if (field.always_display != 'featured') continue
				// if (field.edit_ui != 'textarea') continue		// see above
				if (empty(this.item.cfitem.extensions) || empty(this.item.cfitem.extensions[key])) continue
				get_field_height(key)
			}
		},

		toggle_fe_showing(key) {
			let fekey = this.fek(key)
			this.fe_showing[fekey] = !this.fe_showing[fekey]

			if (this.fe_showing[fekey]) {
				// we have to set it to the exact height to make the transition work so it's animated
				this.fe_style[fekey] = `height:${this.fe_height[fekey] + 0}px;`
			} else {
				this.fe_style[fekey] = `height:${this.min_field_height}px; overflow:hidden;`
			}
		},

		quick_align() {
			let params = {}

			// if we're on an item tile...
			if (!this.item_is_document) {
				// if it's a resource item... 
				if (this.$store.state.site_config.quick_align_resource_types.includes(this.item_type.toLowerCase())) {
					// resource metadata
					// for alignmentMetadata, use extensions.alignmentMetadata if specified, or extensions.description if specified (we'll show this as "description" in the interface)
					let alignmentMetadata = this.item.cfitem.extensions?.alignmentMetadata
						|| this.item.cfitem.extensions?.description
						|| ''
					params.resource_universe_item = {
						resourceSourcedId: this.item.cfitem.extensions?.externalIdentifier ?? this.item.cfitem.identifier,
						title: this.item.cfitem.fullStatement,
						alignmentMetadata: [alignmentMetadata],
					}

					// existing alignments in the quick_align existing_alignments format
					params.existing_alignments = {}
					let ah = this.framework_record.cfo.associations_hash[this.item.cfitem.identifier]
					if (ah) for (let assoc of ah) {
						if (assoc.associationType == 'ext:isAlignedTo') {
							let dest_node = assoc.destinationNodeURI
							let framework_identifier = U.get_framework_identifier_from_node_uri_title(dest_node.title)
							if (framework_identifier) {
								params.existing_alignments[dest_node.identifier] = {
									framework_identifier: framework_identifier,
									item_identifier: dest_node.identifier,
									aligned: true,
								}
							}
						}
					}

					// and specify a callback fn
					params.callback = this.quick_align_callback

				// if we're here this isn't a resource item, so assume we want to run on descendents of this item
				} else {
					params.CASEResourceFrameworkIdentifier = this.framework_record.lsdoc_identifier
					params.CASEGroupIdentifiers = [this.item.cfitem.identifier]
				}
			
			// if we're here this is the document, so just send in the framework identifier
			} else {
				params.CASEResourceFrameworkIdentifier = this.framework_record.lsdoc_identifier
				params.CASEGroupIdentifiers = []
			}

			// note: if we're not viewing a single item, the interface will just let the user run the service and look at the results

			// console.log('quick_align', params)
			vapp.show_resource_quick_align(params)
		},

		quick_align_callback(params) {
			// params should include framework_identifier and cfitem
			// console.warn('quick_align_callback', params)

			// note that the code below was adapted from ResourceAlignmentMixin.js

			// TODO: support crosswalk frameworks; for now we're saving in the current framework
			let association_framework_record = this.framework_record

			// determine if the provided cfitem was already aligned to this resource
			let existing_assoc = false
			let ah = this.framework_record.cfo.associations_hash[this.item.cfitem.identifier]
			if (ah) for (let assoc of ah) {
				if (assoc.associationType == 'ext:isAlignedTo') {
					if (assoc.destinationNodeURI.identifier == params.cfitem.identifier) {
						existing_assoc = assoc
						break
					}
				}
			}

			// if we're creating a new alignment...
			if (!existing_assoc) {
				let data = {
					assoc_save_only: true,			// mark this as assoc_save_only; this allows the save to be executed without requiring a checkout
					update_document_date: 'no',		// don't change the document date
					lsdoc_identifier: association_framework_record.lsdoc_identifier,
					CFAssociations: [],
				}

				// construct association object
				let assoc = {
					// left node is the resource CFItem
					originNodeURI: {
						title: U.generate_cfassociation_node_uri_title_with_framework_identifier(this.item.cfitem, true, this.framework_record.lsdoc_identifier),
						identifier: this.item.cfitem.identifier,
						uri: U.generate_child_uri(this.framework_record.json.CFDocument, this.item.cfitem.identifier, 'CFItems'),
					},

					// right_node_uri is the aligned item
					destinationNodeURI: {
						title: U.generate_cfassociation_node_uri_title_with_framework_identifier(params.cfitem, false, params.framework_identifier),
						identifier: params.cfitem.identifier,
						uri: params.cfitem.uri,
					},

					associationType: 'ext:isAlignedTo',
				}

				// fill in other parts of the CFAssociation object
				assoc = new CFAssociation(assoc)
				assoc.complete_data(association_framework_record.json.CFDocument)	// this will add '*NOW*' as the lastChangeDateTime
				assoc = assoc.to_json()

				data.CFAssociations.push(assoc)

				// console.warn(data); return;

				// data.show_spinner = true
				this.$store.dispatch('save_framework_data', data).then(()=>{
					// update timestamps with the value sent back from the server, then push to store
					for (let assoc of data.CFAssociations) {
						assoc.lastChangeDateTime = this.$store.state.framework_lastChangeDateTime
						this.$store.commit('set', [association_framework_record.json.CFAssociations, 'PUSH', assoc])

						// also update cfo.associations_hash
						U.update_associations_hash(association_framework_record.cfo, assoc)

						// and update associations showing in the tree
						this.viewer.update_association_display({
							framework_id: params.framework_identifier,
							assoc: assoc,
							actions: ['add', 'display']
						})
					}
				})

			// else we're deleting the alignment
			} else {
				let flags = {
					assoc_save_only: true,			// mark this as assoc_save_only; this allows the save to be executed without requiring a checkout
					update_document_date: 'no',		// don't change the document date
				}
				this.viewer.remove_association_finish(existing_assoc, flags)
			}
		},

		//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
		// "Statistics" mode

		stats_mouseover() {
			let i = this.item.cfitem

			let dup
			if (i.stats.is_duplicate_of) dup = i.stats.is_duplicate_of
			else if (i.stats.add_is_child_of_to_duplicate) dup = i.stats.add_is_child_of_to_duplicate
			else if (i.stats.possible_related_to) dup = i.stats.possible_related_to
			else if (i.stats.to_be_deleted) dup = i.stats.to_be_deleted

			if (dup) {
				this.framework_record.cfo.cfitems[dup].stats.duplicate_hovered = true
			}
		},

		stats_mouseout() {
			let i = this.item.cfitem

			let dup
			if (i.stats.is_duplicate_of) dup = i.stats.is_duplicate_of
			else if (i.stats.add_is_child_of_to_duplicate) dup = i.stats.add_is_child_of_to_duplicate
			else if (i.stats.possible_related_to) dup = i.stats.possible_related_to
			else if (i.stats.to_be_deleted) dup = i.stats.to_be_deleted

			if (dup) {
				this.framework_record.cfo.cfitems[dup].stats.duplicate_hovered = false
			}
		},

		stats_clicked() {
			let i = this.item.cfitem

			let dup
			if (i.stats.is_duplicate_of) dup = i.stats.is_duplicate_of
			else if (i.stats.add_is_child_of_to_duplicate) dup = i.stats.add_is_child_of_to_duplicate
			else if (i.stats.possible_related_to) dup = i.stats.possible_related_to
			else if (i.stats.to_be_deleted) dup = i.stats.to_be_deleted

			if (dup) {
				console.log('duplicate_of: ' + dup)
				let search_terms = dup
				if (dup != i.identifier) search_terms += ' OR ' + i.identifier
				this.$store.commit('set', [this.framework_record, 'search_terms', search_terms])
				this.viewer.execute_search_start(false)
			}
		},

		// rough demo showing a "learning check" launching from satchel -- TO ENABLE, set v-if to true in the div above
		open_learning_check() {
			let s = `<div style="margin:-20px; background-color:#fff; padding-top:12px;"><iframe src="http://localhost:7048/itembank/1323" style="width:100%; height:640px; border:0; background-color:#fff"></iframe></div>`
			this.$alert({
				text: s,
				dialogMaxWidth:1200,
				acceptText: 'Done',
			})
		},
	}
}
</script>

<style lang="scss">
.k-case-tree-item-tile-outer {
	width:600px;
	max-width:calc(50vw - 28px);
	border-radius:8px;
	border:1px solid #ddd;
	padding:8px;
	// elevation-2
	box-shadow: 0px 3px 3px -2px rgb(0 0 0 / 20%), 0px 3px 4px 0px rgb(0 0 0 / 14%), 0px 1px 8px 0px rgb(0 0 0 / 12%) !important;
	background-color:#fff;

	font-size:18px;
	line-height:24px;
	position:relative;
	// margin:6px 0;

	pointer-events: auto;

	.fa-thumbtack {
		transform:rotate(30deg);
	}
}

.k-case-tree-item-not-yet-adopted-message, .k-case-tree-item-no-longer-adopted-message, .k-case-tree-item-scheduled-no-longer-adopted-message, .k-case-tree-item-public-review-description { 
		display:none; 
		text-align:center;
		font-size:0.8em;
		color:#fff;
		border-radius:4px;
}
.k-case-tree-item-tile-outer.k-case-tree-item-not-yet-adopted {
	background-color:#eee;
	.k-case-tree-item-not-yet-adopted-message {
		display:block;
		background-color:#444;
	}
}
.k-case-tree-item-tile-outer.k-case-tree-item-no-longer-adopted {
	background-color:$v-red-lighten-5;
	.k-case-tree-item-no-longer-adopted-message {
		display:block;
		background-color:$v-red-darken-4;
	}
}
.k-case-tree-item-tile-outer.k-case-tree-item-scheduled-no-longer-adopted {
	.k-case-tree-item-scheduled-no-longer-adopted-message {
		display:block;
		background-color:$v-red-lighten-4;
		color:#000;
	}
}

.k-case-tree-item-public-review-description {
	text-indent:0;
	margin-left:-4px;
	margin-right:4px;
	margin-top:8px;
	display:block;
	background-color:$v-pink-lighten-5;
	border:1px solid $v-pink-lighten-4;
	color:#000;
}

.k-case-tree-item-tile-framework-header {
	background-color:#333;
	border-radius:8px;
	color:#fff;
	text-align:center;
	padding:4px;
	font-size:16px;
	margin:8px 8px 4px 8px;
}

.k-case-tree-item-tile-inner {
	display:flex;
	align-items:flex-start;
	justify-content: flex-start;
	overflow:visible;
	padding:8px 0;
}

.k-case-tree-item-node-spacer {
	// display:none!important;
	flex: 0 0 8px;
	width: 8px;
	min-width: 8px;
	height: 24px;
}

// adoptionStatus indicators
.k-case-tree-item-adoption-status {
	display:inline-block;
	margin-left:4px;
	padding:0px 6px;
	border:2px solid transparent;
	border-radius:4px;
	text-indent:0;
	font-weight:bold;
	color:#fff;
	background-color:#444;
}

.k-case-tree-item-adoption-status-private_adopted, .k-case-tree-item-adoption-status-adopted, .k-case-tree-item-adoption-status-private_implemented, .k-case-tree-item-adoption-status-implemented {
	background-color:$v-green-darken-3;
}

.k-case-tree-item-adoption-status-private_pending_implementation, .k-case-tree-item-adoption-status-pending_implementation {
	background-color:$v-lime-darken-3;
}

// we used to use "proposed" status for cases where the issuing agency isn't the publisher...
.k-case-tree-item-adoption-status-private_proposed, .k-case-tree-item-adoption-status-proposed {
	background-color:$v-blue-darken-3;
}

// now we check to see if the creator and publisher don't match, and apply this class if so
// note that by putting the class here, it overwrites the "adopted"/"implemented" classes, but not the other ones below
.k-case-tree-item-adoption-status-unofficial {
	background-color:$v-blue-darken-3;
}

.k-case-tree-item-adoption-status-private_draft, .k-case-tree-item-adoption-status-draft {
	background-color:$v-red-darken-3;
}

.k-case-tree-item-adoption-status-private_deprecated, .k-case-tree-item-adoption-status-deprecated, .k-case-tree-item-adoption-status-private_retired, .k-case-tree-item-adoption-status-retired {
	// Retired badges keep white text, so this orange needs to be darker than the Vuetify token to hold AA contrast.
	background-color:#8a3b00;
}
.k-case-tree-item-adoption-status-private_draft, .k-case-tree-item-adoption-status-private_adopted, .k-case-tree-item-adoption-status-private_proposed, .k-case-tree-item-adoption-status-private_deprecated, .k-case-tree-item-adoption-status-private_retired {
	border:2px dashed #666;
}
.k-case-tree-item-details-exemplar-body {
	overflow: auto;

	.k-big-table {
		table-layout: fixed;

		th {
			font-size:0.6em;
			vertical-align:bottom;
			white-space:nowrap;
		}
		td {
			font-size:0.6em;
			vertical-align:top;
		}
	}
}

.k-case-tree-item-tile-outer-has-supp-notes {
	width:880px;
}

// modifications for inline tiles, which could be because the tree is "minimized", or we're on a phone-sized screen
.k-case-tree-item-tile-outer-inline {
	width:calc(100% - 8px);	// this may need to be adjusted for minimized-but-not-phone-sized situation
	max-width: none;
	position:absolute;
	z-index:1;
	left:-10px;
	background-color:#eee;
	font-size:inherit;
	line-height: inherit;
	margin:0px 0 0px 15px;
	padding:4px;
	box-shadow:none!important;

	.k-case-tree-item-details-notes-header, .k-case-tree-item-details-exemplar-header {
		background-color:#eee!important;
	}

	.k-case-tree-item-tile-inner {
		padding:0;
	}

	.k-case-tree-item-statement-hcs:hover {
		text-decoration:underline;
		cursor:pointer;
	}

	.k-case-tree-item-statement:hover {
		cursor:pointer;
	}

	.k-case-tree-item-node-btn {
		margin-right:4px;
		margin-top:-1px;
		width:22px!important;
		height:22px!important;
		.fa-chevron-circle-right { font-size:18px!important; }
		.fa-dot-circle { font-size:18px!important; }
	}
}

.k-case-tree-item-details-notes-inner {
	transition:height 0.25s;
}

.k-case-tree-item-tile {
	padding:1px 0;
	border-radius:6px;
	border:1px solid transparent;
	max-height:calc(100vh - 136px);
	overflow:auto;

	.k-case-tree-item-code-plus-statement {
		white-space: normal;
		// width:calc(100% - 28px);	// if this is just "100%", we get some bad styling if the official source URL is really long
		width:calc(100% - 8px);
		cursor:inherit;
	}

	.k-case-tree-item-statement {
		text-indent:0px;
	}

	.k-tile-comments-wrapper {
		text-indent:0;
		// margin-left:-28px;
		margin-left:-8px;
		margin-top:8px;
	}

	.k-case-tree-item-details {
		text-indent: 0;
		margin-left:0;
		margin-right:8px;
		font-size:0.78em;
		line-height:1.35em;

		.k-case-tree-item-details-inner {
			margin-top:8px;
			border-top:1px solid #ccc;
			padding-top:8px;
		}

		.k-case-tree-item-details-inner-no-border {
			border-top:0;
		}

		.k-case-tree-item-details-inner-item {
			text-align:center;
			display:flex;
			justify-content: space-around;
			align-items:center;
		}

		.k-case-tree-item-details-inner-document {
			font-size:1.0em;
			line-height:1.4em;
		}

		.k-case-tree-item-details-label {
			font-weight:bold;
			color:#666;
			white-space:nowrap;
		}

		.k-case-tree-item-details-notes, .k-case-tree-item-details-exemplar {
			text-indent: 0;
			border:2px solid #aaa;
			border-radius:5px;
			position:relative;
			margin-top:16px;
			padding:8px;

			.fr-view {
				font-size:1.15em;
				line-height:1.4em;
			}

			.k-case-tree-item-details-notes-header, .k-case-tree-item-details-exemplar-header {
				position:absolute;
				margin-top:-17px;
				margin-top:-1.6em;
				margin-left:0px;
				background-color:#fff;
				color:#222;
				font-weight:bold;
				font-size:0.85em;
				padding:0 4px;

				a {
					color:#999;
					font-size:0.8em;
				}
			}
		}

		.k-exemplar-block-header {
			margin:8px 0 4px 0;
			border-top:1px solid #999;
			padding-top:8px;
			cursor:pointer;

			// paragraphs inside k-exemplar-block-header should be treated as inline-block
			p {
				margin:0;
				display:inline-block;
			}

			.fas {
				font-size:18px;
				line-height:16px;
				width:15px;
				color:$v-grey-darken-2;
				text-align:center;
			}
		}
		.k-exemplar-block-header:first-of-type {
			border-top:0;
			padding-top:0;
			margin-top:4px;
		}

		.k-exemplar-block-body {
		}

		.k-exemplar-block-body-no-header {
			margin:8px 0;
			border-top:1px solid #999;
			padding-top:8px;
		}

		.k-exemplar-block-body-no-header:first-of-type {
			border-top:0;
			padding-top:0;
			margin-top:4px;
		}
	}

	.k-case-tree-item-node-btn {
		width:24px!important;
		height:24px!important;
		.fa-chevron-circle-right { font-size:20px!important; }
		.fa-dot-circle { font-size:20px!important; }
		.fa-map { font-size:17px!important; }
	}
	.k-case-tree-item-track-changes-btn .fas {
		font-size:20px!important;
	}
}

.k-case-tree-item-tile-selected .k-case-tree-item-details {
	// PW 6/22/2026: below isn't needed, and in fact causes problems, in post-accessibility version of html
	// margin-left:-31px;	// this compensates for the icon that indicates the item is selected
}

.k-case-tree-markdown {
	// markdown styles
	p, ul, ol, table { margin-bottom:8px; }
}

.k-case-tree-item-tile-node {
	// max-width:600px;
}

.k-case-tree-item-tile-leaf {
}

.k-case-tree-item-tile-search-match {
	// background-color:rgba(0, 0, 0, 0.1)!important;
}

.k-case-tree-item-tile-last-clicked > .k-case-tree-item {
	// border-color:$v-grey-darken-2!important;
}

.v-btn.k-case-tree-item-tile-close-btn {
	position:absolute;
	right:-8px;
	top:-8px;
	background-color:#fff;
}

// .k-case-tree-item-tile-active-with-pinned-items {
// 	width:500px;
// 	max-width:500px;
// }

.k-case-tree-pinned-items-wrapper {
	.k-case-tree-item-tile-outer:not(.k-case-tree-item-tile-outer-full-screen) {
		width:320px;
		max-width:320px;
		padding:0px 12px 0px 4px;
		border-color: transparent!important;
		background-color:#f8f8f8;
		margin-top:8px;
		margin-bottom:8px;

		font-size:12px;
		line-height:15px;
		margin-left:0;

		.k-case-tree-item-node-btn {
			margin-right:3px;
			margin-top:-2px;
			width:20px!important;
			height:20px!important;
			.fa-chevron-circle-right { font-size:15px!important; }
			.fa-dot-circle { font-size:15px!important; }
		}
		// don't show track changes indicators in pinned tiles
		.k-case-tree-item-track-changes-btn {
			display:none;
		}

		.k-case-tree-item-statement-hcs:hover {
			text-decoration:underline;
			cursor:pointer;
		}

		.k-case-tree-item-statement:hover {
			cursor:pointer;
		}

		.k-case-tree-item-associations {
			display:none;
		}

		.k-case-tree-item-details {
			// for now, at least, we don't show any details in pinned standards, because you can click to expand and show everything
			display:none;
		}

		.k-case-tree-item-details-inner {
			display:none!important;
		}

		.k-case-tree-item-tile-close-btn {
			border:1px solid #ccc;
			width:22px;
			height:22px;
			right:-5px;
			top:-5px;
			.fa-thumbtack { font-size:13px!important; }
		}
	}
}

// @media (max-height: 824px) {
// 	.k-case-tree-item-tile-outer-full-screen {
// 		margin-top:0;
// 	}
// }

</style>
